<template>
    <div id="box">
        <hometop :id="0"></hometop>
        <div class="w1200 mt20 clear">
            <div class="fl w210 bgwhite h700">
                <div class="menu-title">
                    物流行业
                    <router-link :to="{ name: 'industryIndex' }" class="f12 color9 fr">
                        更多
                        <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                    </router-link>
                </div>
                <div class="logisticslist" @mouseenter="showlogistic = true" @mouseleave="showlogistic = false">
                    <ul>
                        <li>
                            <router-link :to="{
                  name: 'logisticsIndustry',
                  query: { logisticsid: 1, menuTle: '物流交易' },
                }">
                                <i class="wljy"></i>物流交易
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{
                  name: 'logisticsIndustry',
                  query: { logisticsid: 2, menuTle: '物流信息' },
                }">
                                <i class="wlxx"></i>物流信息
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{
                  name: 'logisticsIndustry',
                  query: { logisticsid: 21, menuTle: '物流专线' },
                }">
                                <i class="wlzx"></i>物流专线
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{
                  name: 'logisticsIndustry',
                  query: { logisticsid: 3, menuTle: '零担物流' },
                }">
                                <i class="ldwl"></i>零担物流
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{
                  name: 'logisticsIndustry',
                  query: { logisticsid: 4, menuTle: '城市配送' },
                }">
                                <i class="csps"></i>城市配送
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{
                  name: 'logisticsIndustry',
                  query: { logisticsid: 5, menuTle: '仓配资源' },
                }">
                                <i class="cpzy"></i>仓配资源
                            </router-link>
                        </li>
                    </ul>
                    <div class="hoverbox" v-if="showlogistic">
                        <ul>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 1, menuTle: '物流交易' },
                  }">
                                    <i class="wljy"></i>物流交易
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 2, menuTle: '物流信息' },
                  }">
                                    <i class="wlxx"></i>物流信息
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 21, menuTle: '物流专线' },
                  }">
                                    <i class="wlzx"></i>物流专线
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 3, menuTle: '零担物流' },
                  }">
                                    <i class="ldwl"></i>零担物流
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 4, menuTle: '城市配送' },
                  }">
                                    <i class="csps"></i>城市配送
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 5, menuTle: '仓配资源' },
                  }">
                                    <i class="cpzy"></i>仓配资源
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 6, menuTle: '物流园区' },
                  }">
                                    <i class="wlyq"></i>物流园区
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 7, menuTle: '铁路物流' },
                  }">
                                    <i class="tlwl"></i>铁路物流
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 8, menuTle: '海运物流' },
                  }">
                                    <i class="hywl"></i>海运物流
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 9, menuTle: '空运物流' },
                  }">
                                    <i class="kywl"></i>空运物流
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 10, menuTle: '多式联运' },
                  }">
                                    <i class="dsly"></i>多式联运
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 11, menuTle: '冷链物流' },
                  }">
                                    <i class="llwl"></i>冷链物流
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 12, menuTle: '医药物流' },
                  }">
                                    <i class="yywl"></i>医药物流
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 13, menuTle: '危化物流' },
                  }">
                                    <i class="whwl"></i>危化物流
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 14, menuTle: '大件物流' },
                  }">
                                    <i class="djwl"></i>大件物流
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 23, menuTle: '港口物流' },
                  }">
                                    <i class="gkwl"></i>港口物流
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 24, menuTle: '应急物流' },
                  }">
                                    <i class="yjwl"></i>应急物流
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 15, menuTle: '货车销售' },
                  }">
                                    <i class="hcxs"></i>货车销售
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 16, menuTle: '后车市场' },
                  }">
                                    <i class="hcsc"></i>后车市场
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 17, menuTle: '物流装备' },
                  }">
                                    <i class="wlzb"></i>物流装备
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 18, menuTle: '物流信息化' },
                  }">
                                    <i class="wlxxh"></i>物流信息化
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{
                    name: 'logisticsIndustry',
                    query: { logisticsid: 19, menuTle: '物流金融' },
                  }">
                                    <i class="wljr"></i>物流金融
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="menu-title">
                    行业物流
                    <router-link :to="{ name: 'logisticsIndex' }" class="f12 color9 fr">
                        更多
                        <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                    </router-link>
                </div>
                <div class="indistrylist" @mouseenter="showindistry = true" @mouseleave="showindistry = false">
                    <ul>
                        <li>
                            <a href="http://www.ynl086.com/" target="_blank">
                                <i class="wljy1"></i>耐火材料行业物流
                            </a>
                        </li>
                        <li>
                            <a href="http://www.gyb086.com/" target="_blank">
                                <i class="yjll1"></i>冶金炉料行业物流
                            </a>
                        </li>
                        <li>
                            <a href="http://www.lxt086.com/" target="_blank">
                                <i class="tchy1"></i>陶瓷行业物流
                            </a>
                        </li>
                        <li>
                            <a href="http://www.yyj086.com/" target="_blank">
                                <i class="yyjhy1"></i>应急行业物流
                            </a>
                        </li>
                    </ul>
                    <div class="hoverbox" v-if="showindistry">
                        <ul>
                            <li>
                                <a href="http://www.ynl086.com/" target="_blank">
                                    <i class="wljy2"></i>耐火材料行业物流
                                </a>
                            </li>
                            <li>
                                <a href="http://www.gyb086.com/" target="_blank">
                                    <i class="yjll"></i>冶金炉料行业物流
                                </a>
                            </li>
                            <li>
                                <a href="http://www.lxt086.com/" target="_blank">
                                    <i class="tchy"></i>陶瓷行业物流
                                </a>
                            </li>
                            <li>
                                <a href="http://www.yyj086.com/" target="_blank">
                                    <i class="yyjhy"></i>应急行业物流
                                </a>
                            </li>
                            <li>
                                <span @click="loading('钢铁行业物流')">
                                    <i class="gthy"></i>钢铁行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('水泥行业物流')">
                                    <i class="snhy"></i>水泥行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('煤炭行业物流')">
                                    <i class="mthy"></i>煤炭行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('化工行业物流')">
                                    <i class="hghy"></i>化工行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('有色金属行业物流')">
                                    <i class="ysjs"></i>有色金属行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('玻璃行业物流')">
                                    <i class="bolhy"></i>玻璃行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('塑料行业物流')">
                                    <i class="slhy"></i>塑料行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('木材行业物流')">
                                    <i class="mchy"></i>木材行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('食品行业物流')">
                                    <i class="sphy"></i>食品行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('农产品行业物流')">
                                    <i class="ncphy"></i>农产品行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('医药行业物流')">
                                    <i class="yyhy"></i>医药行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('酒业行业物流')">
                                    <i class="jdhy"></i>酒业行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('五金行业物流')">
                                    <i class="wjhy"></i>五金行业物流
                                </span>
                            </li>
                            <li>
                                <span @click="loading('汽配行业物流')">
                                    <i class="qphy"></i>汽配行业物流
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="menu-title">
                    区域物流
                    <router-link :to="{ name: 'nodelist' }" class="f12 color9 fr">
                        更多
                        <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                    </router-link>
                </div>
                <div class="logisticslist" @mouseenter="showcity = true" @mouseleave="showcity = false">
                    <ul>
                        <li @click="changeurl('物流遵化')">物流遵化</li>
                        <li @click="changeurl('物流丰润')">物流丰润</li>
                        <li @click="changeurl('物流开平')">物流开平</li>
                        <li @click="changeurl('物流古冶')">物流古冶</li>
                        <li @click="changeurl('物流滦州')">物流滦州</li>
                        <li @click="changeurl('物流迁西')">物流迁西</li>
                        <li @click="changeurl('物流路北')">物流路北</li>
                        <li @click="changeurl('物流路南')">物流路南</li>
                    </ul>
                    <div class="hoverbox het195" v-if="showcity">
                        <ul>
                            <li @click="changeurl('物流遵化')">物流遵化</li>
                            <li @click="changeurl('物流丰润')">物流丰润</li>
                            <li @click="changeurl('物流开平')">物流开平</li>
                            <li @click="changeurl('物流古冶')">物流古冶</li>
                            <li @click="changeurl('物流滦州')">物流滦州</li>
                            <li @click="changeurl('物流迁西')">物流迁西</li>
                            <li @click="changeurl('物流路北')">物流路北</li>
                            <li @click="changeurl('物流路南')">物流路南</li>
                            <li @click="changeurl('物流丰南')">物流丰南</li>
                            <li @click="changeurl('物流滦南')">物流滦南</li>
                            <li @click="changeurl('物流玉田')">物流玉田</li>
                            <li @click="changeurl('物流乐亭')">物流乐亭</li>
                            <li @click="changeurl('物流海港')">物流海港</li>
                            <li @click="changeurl('物流曹妃甸')">物流曹妃甸</li>
                            <li @click="changeurl('物流迁安')">物流迁安</li>
                            <li @click="changeurl('物流芦台')">物流芦台</li>
                            <li @click="changeurl('物流汉沽')">物流汉沽</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="fl ml20">
                <div class="w670 bgwhite ht365 plr14">
                    <div class="t_tle">
                        <span class="f20 color3">{{ comUrl.nodeCity.name }}物流资源分布图</span>
                    </div>
                    <div class="t_zyfbtlist">
                        <el-tabs :tab-position="tabPosition" v-model="activeName4" @tab-click="handleClick">
                            <template v-for="(item, index) in wallmap">
                                <el-tab-pane :label="item.nvcName" :name="commJs.getString(item.iPiIdentifier)" :key="item.iPiIdentifier" v-if="index < 6">
                                    <router-link target="_blank" :to="{
                      name: 'distribution',
                      query: { id: item.iPiIdentifier },
                    }">
                                        <el-image :src="item.nvcUrl" style="width: 670px; height: 300px" :alt="item.nvcName"></el-image>
                                    </router-link>
                                </el-tab-pane>
                            </template>
                        </el-tabs>
                    </div>
                </div>

                <div class="w670 bgwhite ht315 plr14 mt20" id="association">
                    <div class="t_tle">
                        <span class="f20 color3">{{ comUrl.nodeCity.name }}物流行业协会</span>
                    </div>
                    <div class="t_xhcontent">
                        <router-link :to="{ name: 'association' }">
                            <el-image :src="xhjj.logo" :fit="fit" style="width: 670px; height: 73px" :alt="comUrl.nodeCity.name + '物流行业协会'"></el-image>
                        </router-link>
                        <div class="t_onte">
                            {{ xhjj.content }}
                            <router-link :to="{ name: 'association' }" class="color_sub">[查看更多]</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fr">
                <div class="w224 bgwhite ht365 plr14">
                    <div v-if="isshowit === 'true'">
                        <div class="ht60">
                            Hi，
                            <span class="color_sub" v-if="username.length > 11">
                                {{
                                commJs.limitNum(username, 11)
                                }}
                            </span>
                            <span class="color_sub" v-else>{{ username }}</span>
                            ，
                            <br />欢迎来到物流唐山！
                            <div>
                                <router-link :to="{ name: 'roomindex', query: { roomid: userid } }" class="blue_botton">展厅前台</router-link>
                                <router-link :to="{ name: 'releaseresources' }" class="blue_botton blue_border ml5">展厅后台</router-link>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="ht45">Hi，欢迎来到物流唐山！</div>
                        <div class="ht28t">
                            <router-link :to="{ name: 'login' }" class="blue_botton">登录</router-link>
                            <router-link :to="{ name: 'register' }" class="blue_botton blue_border ml5">注册</router-link>
                        </div>
                    </div>
                    <div class="t_tle bortop mt25">
                        <a @click="openView" class="f12 color9 fr" style="margin-top: 8px">
                            更多
                            <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                        </a>
                        <el-tabs v-model="activeName3" @tab-click="handleClick" class="t_redtle">
                            <el-tab-pane label="热点新闻" name="first">
                                <div class="t_li">
                                    <ul>
                                        <li v-for="item in HotNewsList" :key="item.iNIdentifier">
                                            <router-link
                                                :to="{
                          name: 'logisticsnewsdetail',
                          query: { id: item.iNIdentifier, type: 15 },
                        }"
                                                :title="
                          item.nvcTitle.length < 15 ? false : item.nvcTitle
                        "
                                            >
                                                <span>·</span>
                                                {{ item.nvcTitle }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="本网动态" name="second">
                                <div class="t_li">
                                    <ul>
                                        <li v-for="item in NewsList" :key="item.iNIdentifier">
                                            <router-link
                                                :to="{
                          name: 'logisticsnewsdetail',
                          query: { id: item.iNIdentifier, type: 2 },
                        }"
                                                :title="
                          item.nvcTitle.length < 15 ? false : item.nvcTitle
                        "
                                            >
                                                <span>·</span>
                                                {{ item.nvcTitle }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
                <div class="w252 bgwhite ht315 mt20">
                    <div class="t_tle center">
                        <span class="f20 color3">入会申请</span>
                    </div>
                    <div class="t_rhapply">
                        <ul>
                            <li>
                                <router-link :to="{ name: 'associationapply', query: { applyId: '1' } }">
                                    <span>
                                        <i class="rh"></i>
                                    </span>入会流程
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'associationapply', query: { applyId: '2' } }">
                                    <span>
                                        <i class="sq"></i>
                                    </span>入会申请
                                </router-link>
                            </li>
                            <li class="mt15">
                                <router-link :to="{ name: 'associationapply', query: { applyId: '3' } }">
                                    <span>
                                        <i class="yjzj"></i>
                                    </span>意见征集
                                </router-link>
                            </li>
                            <li class="mt15">
                                <router-link :to="{ name: 'associationapply', query: { applyId: '4' } }">
                                    <span>
                                        <i class="fwxm"></i>
                                    </span>服务项目
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="w1200 mt20 clear">
            <ul class="index_ad_item">
                <li class="w6_3">
                    <img src="/static/images/yxrhy.png" />
                    <i class="index_ad_icon"></i>
                </li>
                <li class="w6_3">
                    <img src="/static/images/flkj.png" />
                    <i class="index_ad_icon"></i>
                </li>
            </ul>
        </div>
        <div id="dynamic">
            <div class="w1200 mt20 clear">
                <div class="plr17 fl w556 bgwhite ht310">
                    <div class="t_tle">
                        <i class="title_icon fl"></i>
                        <span class="f20 color3 fl">{{ comUrl.nodeCity.name }}物流协会动态</span>
                        <router-link :to="{ name: 'newsletters', query: { type: 12 } }" class="f12 color9 fr">
                            更多
                            <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                        </router-link>
                    </div>
                    <div class="mt5 pb10 xhhylist" v-if="newsletter.length > 0">
                        <ul>
                            <template v-for="(item, index) in newsletter">
                                <li v-if="index == 0" :key="index">
                                    <router-link
                                        :to="{
                      name: 'newslettersdetail',
                      query: { id: item.iNIdentifier, type: item.iNewsType },
                    }"
                                        class="fl img"
                                    >
                                        <el-image
                                            style="width: 254px; height: 132px"
                                            :src="
                        item.nvcImgurl
                          ? item.nvcImgurl
                          : './static/images/nopic.png'
                      "
                                            fit="cover"
                                            :alt="item.nvcImgurl ? item.nvcTitle : ''"
                                        >
                                            <div slot="error">
                                                <img src="/static/images/nopic.png" width="254" height="132" style="object-fit: cover" />
                                            </div>
                                        </el-image>
                                    </router-link>
                                    <div class="fr w290">
                                        <router-link
                                            :to="{
                        name: 'newslettersdetail',
                        query: { id: item.iNIdentifier, type: item.iNewsType },
                      }"
                                            class="f18 color3"
                                        >
                                            <span
                                                v-if="
                          item.nvcTitle !== null && item.nvcTitle.length > 15
                        "
                                                :title="item.nvcTitle"
                                            >{{ commJs.limitNum(item.nvcTitle, 15) }}</span>
                                            <span v-else>{{ item.nvcTitle }}</span>
                                        </router-link>
                                        <p
                                            class="color9 mt5"
                                            v-if="
                        item.nvcNewsContent !== null &&
                        item.nvcNewsContent.length > 75
                      "
                                        >
                                            {{
                                            commJs.limitNum(
                                            commJs.removeLab(item.nvcNewsContent),
                                            75
                                            )
                                            }}
                                            <router-link
                                                :to="{
                          name: 'newslettersdetail',
                          query: {
                            id: item.iNIdentifier,
                            type: item.iNewsType,
                          },
                        }"
                                                class="color_sub"
                                            >[详情]</router-link>
                                        </p>
                                        <p class="color9 mt5" v-else>{{ commJs.removeLab(item.nvcNewsContent) }}</p>
                                    </div>
                                </li>
                                <li v-else-if="index < 4" :key="index">
                                    <router-link
                                        :to="{
                      name: 'newslettersdetail',
                      query: { id: item.iNIdentifier, type: item.iNewsType },
                    }"
                                        :title="item.nvcTitle.length < 30 ? false : item.nvcTitle"
                                        class="f14 color3"
                                    >{{ item.nvcTitle }}</router-link>
                                    <span class="color9 fr">
                                        {{
                                        item.dtPublishTime | formatDate2
                                        }}
                                    </span>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <div class="plr17 fr w556 bgwhite ht310">
                    <div class="t_tle">
                        <i class="title_icon fl"></i>
                        <span class="f20 color3 fl">{{ comUrl.nodeCity.name }}物流协会会员动态</span>
                        <router-link :to="{ name: 'newsletters', query: { type: 0 } }" class="f12 color9 fr">
                            更多
                            <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                        </router-link>
                    </div>
                    <div class="mt5 pb10 xhhylist" v-if="memberlist !== null && memberlist.length > 0">
                        <ul>
                            <template v-for="(item, index) in memberlist">
                                <li v-if="index == 0" :key="index">
                                    <router-link
                                        :to="{
                      name: 'newslettersdetail',
                      query: { id: item.iNIdentifier, type: item.iNewsType },
                    }"
                                        class="fl img"
                                    >
                                        <el-image
                                            style="width: 254px; height: 132px"
                                            :src="
                        item.nvcImgurl
                          ?  item.nvcImgurl
                          :'./static/images/nopic.png'
                      "
                                            fit="cover"
                                            :alt="item.nvcImgurl ? item.nvcTitle : ''"
                                        >
                                            <div slot="error">
                                                <img src="/static/images/nopic.png" width="254" height="132" style="object-fit: cover" />
                                            </div>
                                        </el-image>
                                    </router-link>
                                    <div class="fr w290">
                                        <router-link
                                            :to="{
                        name: 'newslettersdetail',
                        query: { id: item.iNIdentifier, type: item.iNewsType },
                      }"
                                            class="f18 color3"
                                        >
                                            <span
                                                v-if="
                          item.nvcTitle !== null && item.nvcTitle.length > 15
                        "
                                                :title="item.nvcTitle"
                                            >{{ commJs.limitNum(item.nvcTitle, 15) }}</span>
                                            <span v-else>{{ item.nvcTitle }}</span>
                                        </router-link>
                                        <p
                                            class="color9 mt5"
                                            v-if="
                        item.nvcNewsContent !== null &&
                        item.nvcNewsContent.length > 75
                      "
                                        >
                                            {{
                                            commJs.limitNum(
                                            commJs.removeLab(item.nvcNewsContent),
                                            75
                                            )
                                            }}
                                            <router-link
                                                :to="{
                          name: 'newslettersdetail',
                          query: {
                            id: item.iNIdentifier,
                            type: item.iNewsType,
                          },
                        }"
                                                class="color_sub"
                                            >[详情]</router-link>
                                        </p>
                                        <p class="color9 mt5" v-else>{{ commJs.removeLab(item.nvcNewsContent) }}</p>
                                    </div>
                                </li>
                                <li v-else-if="index < 4" :key="index">
                                    <router-link
                                        :to="{
                      name: 'newslettersdetail',
                      query: { id: item.iNIdentifier, type: item.iNewsType },
                    }"
                                        :title="item.nvcTitle.length < 30 ? false : item.nvcTitle"
                                        class="f14 color3"
                                    >{{ item.nvcTitle }}</router-link>
                                    <span class="color9 fr">
                                        {{
                                        item.dtPublishTime | formatDate2
                                        }}
                                    </span>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div class="w1200 mt20 clear">
            <ul class="index_ad_item">
                <li class="w6_3">
                    <img src="/static/images/txqp.png" />
                    <i class="index_ad_icon"></i>
                </li>
                <li class="w6_3">
                    <img src="/static/images/fhgc.png" />
                    <i class="index_ad_icon"></i>
                </li>
            </ul>
        </div>
        <div id="committee">
            <div class="w1200 mt20 bgwhite clear" v-if="CommitteeList.nvcName">
                <div class="plr17">
                    <div class="t_tle">
                        <i class="title_icon fl"></i>
                        <span class="f20 color3 fl">{{ comUrl.nodeCity.name }}行业物流专业委员会</span>
                        <router-link :to="{ name: 'committee' }" class="f12 color9 fr">
                            更多
                            <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                        </router-link>
                        <div class="clear"></div>
                    </div>
                    <div class="mt5 pb10">
                        <div class="fl w570">
                            <div class="t_index_zhulist">
                                <span class="f16">{{ CommitteeList.nvcName }}</span>
                                <router-link
                                    :to="{
                    name: 'committeelist',
                    query: { committeeId: CommitteeList.iScIdentifier },
                  }"
                                    class="f12 color9 fr"
                                >
                                    更多
                                    <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                                </router-link>
                            </div>
                            <el-table :data="CommitteeList.companyList" :show-header="false" width="100%" class="t_table">
                                <el-table-column prop="nvcCompanyName">
                                    <template slot-scope="scope">
                                        <router-link
                                            :to="{
                        name: 'roomindex',
                        query: { roomid: scope.row.iUiIdentifier },
                      }"
                                        >{{ scope.row.nvcCompanyName }}</router-link>
                                        <span v-if="scope.row.iMemberType == '37'" class="ml5">
                                            <el-image src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px"></el-image>
                                        </span>
                                        <span v-if="scope.row.iMemberType == '38'" class="ml5">
                                            <el-image src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px"></el-image>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="nvcContact" width="150">
                                    <template slot-scope="scope">联系人：{{ scope.row.nvcContact || "--" }}</template>
                                </el-table-column>
                                <el-table-column prop="nvcContactPhone" width="150" align="center">
                                    <template slot-scope="scope">
                                        <span v-if="isshowit === 'true'">
                                            <span v-if="isvip == '37' || isvip == '38'">
                                                {{
                                                scope.row.nvcContactPhone || "--"
                                                }}
                                            </span>
                                            <span v-else class="color_main cursor" @click="isvipmember">查看</span>
                                        </span>
                                        <span v-else>
                                            <router-link :to="{ name: 'login' }">查看</router-link>
                                        </span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="fr w570">
                            <div class="t_index_zhulist">
                                <span class="f16">{{ CommitteeList2.nvcName }}</span>
                                <router-link
                                    :to="{
                    name: 'committeelist',
                    query: { committeeId: CommitteeList2.iScIdentifier },
                  }"
                                    class="f12 color9 fr"
                                >
                                    更多
                                    <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                                </router-link>
                            </div>
                            <el-table :data="CommitteeList2.companyList" :show-header="false" style="width: 100%" class="t_table fr">
                                <el-table-column prop="nvcCompanyName">
                                    <template slot-scope="scope">
                                        <router-link
                                            :to="{
                        name: 'roomindex',
                        query: { roomid: scope.row.iUiIdentifier },
                      }"
                                        >{{ scope.row.nvcCompanyName }}</router-link>
                                        <span v-if="scope.row.iMemberType == '37'" class="ml5">
                                            <el-image src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px"></el-image>
                                        </span>
                                        <span v-if="scope.row.iMemberType == '38'" class="ml5">
                                            <el-image src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px"></el-image>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="nvcContact" width="150">
                                    <template slot-scope="scope">联系人：{{ scope.row.nvcContact || "--" }}</template>
                                </el-table-column>
                                <el-table-column prop="nvcContactPhone" width="150" align="center">
                                    <template slot-scope="scope">
                                        <span v-if="isshowit === 'true'">
                                            <span v-if="isvip == '37' || isvip == '38'">
                                                {{
                                                scope.row.nvcContactPhone || "--"
                                                }}
                                            </span>
                                            <span v-else class="color_main cursor" @click="isvipmember">查看</span>
                                        </span>
                                        <span v-else>
                                            <router-link :to="{ name: 'login' }">查看</router-link>
                                        </span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w1200 mt20 clear">
            <ul class="index_ad_item">
                <li class="w6_2">
                    <img src="/static/images/54932.png" />
                    <i class="index_ad_icon"></i>
                </li>
                <li class="w6_2">
                    <img src="/static/images/55029.png" />
                    <i class="index_ad_icon"></i>
                </li>
                <li class="w6_2">
                    <img src="/static/images/ad_d2.png" />
                    <i class="index_ad_icon"></i>
                </li>
            </ul>
        </div>
        <div id="transaction">
            <div class="w1200 mt20 bgwhite clear">
                <div class="plr17">
                    <div class="t_tle">
                        <i class="title_icon fl"></i>
                        <span class="f20 color3 fl">{{ comUrl.nodeCity.name }}物流交易</span>
                        <router-link :to="{ name: 'logisticstrade' }" class="f12 color9 fr" v-if="SupplyTradeList.length == 5">
                            更多
                            <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                        </router-link>
                        <div class="fr mr15 sebox">
                            <el-form ref="form" :model="form">
                                <el-form-item>
                                    <el-col class="ht32 w200 index-select">
                                        <!-- <el-input v-model="form.transactionbegin" placeholder="请选择装货地"></el-input> -->
                                        <el-cascader
                                            v-model="form.transactionbegin"
                                            :options="options"
                                            :props="{ expandTrigger: 'hover', checkStrictly: true }"
                                            placeholder="请选择装货地"
                                            @change="handleChange"
                                        ></el-cascader>
                                    </el-col>
                                    <el-col class="ml5 ht32 w200 index-select">
                                        <!-- <el-input v-model="form.transactionend" placeholder="请选择卸货地"></el-input> -->
                                        <el-cascader
                                            v-model="form.transactionend"
                                            :options="options"
                                            :props="{ expandTrigger: 'hover', checkStrictly: true }"
                                            placeholder="请选择卸货地"
                                            @change="handleChange"
                                        ></el-cascader>
                                    </el-col>
                                    <el-col class="ht30 w65 ml5 mr18">
                                        <el-button
                                            type="primary"
                                            @click="
                        jumpPath2(
                          'logisticstrade',
                          form.transactionbegin,
                          form.transactionend
                        )
                      "
                                            class="orang_button ht30 w65"
                                        >搜索</el-button>
                                    </el-col>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="mt5 pb10">
                        <el-table :data="SupplyTradeList" style="width: 100%" class="t_table">
                            <el-table-column prop="nvcLogisticsName" label="行业" width="100" align="center">
                                <template slot-scope="scope">
                                    {{
                                    scope.row.nvcLogisticsName || "--"
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="nvcOriginating" label="装货地" width="230">
                                <template slot-scope="scope">
                                    <span class="nowrap">
                                        {{
                                        scope.row.nvcOriginating || "--"
                                        }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nvcDumpingGroundAddress" label="卸货地" width="230">
                                <template slot-scope="scope">
                                    {{
                                    scope.row.nvcDumpingGroundAddress || "--"
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="nvcCommodityName" label="货物名称" width="200">
                                <template slot-scope="scope">
                                    <router-link
                                        :to="{
                      name: 'goodsdetails',
                      query: {
                        roomid: scope.row.iUiIdentifier,
                        detailid: scope.row.iStIdentifier,
                      },
                    }"
                                    >{{ scope.row.nvcCommodityName }}</router-link>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="nvcGoodtype" label="货物类型" width="100" align="center"></el-table-column> -->
                            <el-table-column prop="nvcUnitStr" label="货量" width="96"></el-table-column>
                            <!-- <el-table-column prop="nvcTransporttype" label="运输类型" width="80" align="center"></el-table-column>
                            <el-table-column prop="nvcCarmodel" label="车型要求" width="80" align="center"></el-table-column>-->
                            <el-table-column prop="nvcCarlong" label="车长要求" width="90" align="center"></el-table-column>
                            <el-table-column prop="dtSendTime" label="装货时间" width="110" align="center">
                                <template slot-scope="scope">
                                    {{
                                    scope.row.dtSendTime
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="110" align="center">
                                <template slot-scope="scope">
                                    <el-button @click="handleClicktwo(scope.row.iStIdentifier)" type="text" size="small" class="opetion">抢单</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <div id="park">
            <div class="w1200 mt20 bgwhite clear">
                <div class="plr17 position_rel">
                    <div class="t_tle">
                        <i class="title_icon fl"></i>
                        <span class="f20 color3 fl">{{ comUrl.nodeCity.name }}物流园区</span>
                        <router-link :to="{ name: 'logisticspark', query: { serId: theid } }" class="f12 color9 fr" v-if="showparkmore">
                            更多
                            <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                        </router-link>
                        <div class="fr mr15 sebox">
                            <el-form ref="form" :model="form">
                                <el-form-item>
                                    <el-col class="ht32 w320">
                                        <el-input v-model="form.parkname" placeholder="请输入物流园区名称关键字"></el-input>
                                    </el-col>
                                    <el-col class="ht30 w65 ml5">
                                        <el-button type="primary" @click="jumpPath('logisticspark', form.parkname)" class="orang_button ht30 w65">搜索</el-button>
                                    </el-col>
                                    <el-col class="ht30 w80 ml10 mr18 blue">
                                        <span v-if="isshowit === 'true'">
                                            <router-link :to="{ name: 'parkpublished' }" class="orang_button ht30 w80 show center bg_blue">我要发布</router-link>
                                        </span>
                                        <span v-else>
                                            <router-link :to="{ name: 'login' }" class="orang_button ht30 w80 show center bg_blue">我要发布</router-link>
                                        </span>
                                    </el-col>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <el-tabs v-model="activeName1" @tab-click="handleClick">
                        <el-tab-pane label="全部" name="first">
                            <div class="t_img_li">
                                <ul>
                                    <li v-for="item in ParkList" :key="item.iPrIdentifier">
                                        <router-link
                                            :to="{
                        name: 'logisticsparkdetails',
                        query: {
                          roomid: item.iUiIdentifier,
                          detailid: item.iPrIdentifier,
                        },
                      }"
                                            class="position_rel"
                                        >
                                            <div v-if="
                          item.imgUrlList !== null && item.imgUrlList.length > 0
                        ">
                                                <template v-for="(ite, index2) in item.imgUrlList">
                                                    <el-image
                                                        style="
                              width: 220px;
                              height: 220px;
                              background: #fbfbfb;
                            "
                                                        :src="ite.nvcImage"
                                                        :fit="fit"
                                                        :alt="item.nvcParkName"
                                                        :key="index2"
                                                        v-if="index2 == 0"
                                                    ></el-image>
                                                </template>
                                            </div>
                                            <div v-else>
                                                <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                            </div>
                                            <div class="t_tjimg">
                                                <img src="/static/images/tj_icon.png" />
                                            </div>
                                        </router-link>
                                        <div class="color9 mt10">
                                            <router-link
                                                :to="{
                          name: 'logisticsparkdetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iPrIdentifier,
                          },
                        }"
                                                class="f16 color3"
                                            >
                                                <span
                                                    v-if="
                            item.nvcParkName !== null &&
                            item.nvcParkName.length > 10
                          "
                                                    :title="item.nvcParkName"
                                                >{{ commJs.limitNum(item.nvcParkName, 10) }}</span>
                                                <span v-else>{{ item.nvcParkName }}</span>
                                            </router-link>
                                            <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                            <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                        </div>
                                        <div class="color9">
                                            <span class="fl">
                                                <i class="iconfont icon-fuwuleixing"></i>
                                                {{ item.nvcParkServiceType }}
                                            </span>
                                            <span class="fr">
                                                <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                {{ item.nvcParkTotalArea }}亩
                                            </span>
                                        </div>
                                        <div class="color9">
                                            <i class="iconfont icon-diqu f14"></i>
                                            <span
                                                v-if="
                          item.nvcParkAddress !== null &&
                          item.nvcParkAddress.length > 12
                        "
                                                :title="item.nvcParkAddress"
                                            >{{ commJs.limitNum(item.nvcParkAddress, 12) }}</span>
                                            <span v-else>{{ item.nvcParkAddress }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="货运型" name="firstd" v-if="ParkList6.length > 0">
                            <div class="t_img_li">
                                <ul>
                                    <li v-for="item in ParkList6" :key="item.iPrIdentifier">
                                        <router-link
                                            :to="{
                        name: 'logisticsparkdetails',
                        query: {
                          roomid: item.iUiIdentifier,
                          detailid: item.iPrIdentifier,
                        },
                      }"
                                            class="position_rel"
                                        >
                                            <div v-if="
                          item.imgUrlList !== null && item.imgUrlList.length > 0
                        ">
                                                <template v-for="(ite, index2) in item.imgUrlList">
                                                    <el-image
                                                        style="
                              width: 220px;
                              height: 220px;
                              background: #fbfbfb;
                            "
                                                        :src="ite.nvcImage"
                                                        :fit="fit"
                                                        :alt="item.nvcParkName"
                                                        :key="index2"
                                                        v-if="index2 == 0"
                                                    ></el-image>
                                                </template>
                                            </div>
                                            <div v-else>
                                                <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                            </div>
                                            <div class="t_tjimg">
                                                <img src="/static/images/tj_icon.png" />
                                            </div>
                                        </router-link>
                                        <div class="color9 mt10">
                                            <router-link
                                                :to="{
                          name: 'logisticsparkdetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iPrIdentifier,
                          },
                        }"
                                                class="f16 color3"
                                            >
                                                <span
                                                    v-if="
                            item.nvcParkName !== null &&
                            item.nvcParkName.length > 10
                          "
                                                    :title="item.nvcParkName"
                                                >{{ commJs.limitNum(item.nvcParkName, 10) }}</span>
                                                <span v-else>{{ item.nvcParkName }}</span>
                                            </router-link>
                                            <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                            <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                        </div>
                                        <div class="color9">
                                            <span class="fl">
                                                <i class="iconfont icon-fuwuleixing"></i>
                                                {{ item.nvcParkServiceType }}
                                            </span>
                                            <span class="fr">
                                                <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                {{ item.nvcParkTotalArea }}亩
                                            </span>
                                        </div>
                                        <div class="color9">
                                            <i class="iconfont icon-diqu f14"></i>
                                            <span
                                                v-if="
                          item.nvcParkAddress !== null &&
                          item.nvcParkAddress.length > 12
                        "
                                                :title="item.nvcParkAddress"
                                            >{{ commJs.limitNum(item.nvcParkAddress, 12) }}</span>
                                            <span v-else>{{ item.nvcParkAddress }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="生产型" name="second" v-if="ParkList1.length > 0">
                            <div class="t_img_li">
                                <ul>
                                    <li v-for="item in ParkList1" :key="item.iPrIdentifier">
                                        <router-link
                                            :to="{
                        name: 'logisticsparkdetails',
                        query: {
                          roomid: item.iUiIdentifier,
                          detailid: item.iPrIdentifier,
                        },
                      }"
                                            class="position_rel"
                                        >
                                            <div v-if="
                          item.imgUrlList !== null && item.imgUrlList.length > 0
                        ">
                                                <template v-for="(ite, index2) in item.imgUrlList">
                                                    <el-image
                                                        style="
                              width: 220px;
                              height: 220px;
                              background: #fbfbfb;
                            "
                                                        :src="ite.nvcImage"
                                                        :fit="fit"
                                                        :alt="item.nvcParkName"
                                                        :key="index2"
                                                        v-if="index2 == 0"
                                                    ></el-image>
                                                </template>
                                            </div>
                                            <div v-else>
                                                <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                            </div>
                                            <div class="t_tjimg">
                                                <img src="/static/images/tj_icon.png" />
                                            </div>
                                        </router-link>
                                        <div class="color9 mt10">
                                            <router-link
                                                :to="{
                          name: 'logisticsparkdetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iPrIdentifier,
                          },
                        }"
                                                class="f16 color3"
                                            >
                                                <span
                                                    v-if="
                            item.nvcParkName !== null &&
                            item.nvcParkName.length > 10
                          "
                                                    :title="item.nvcParkName"
                                                >{{ commJs.limitNum(item.nvcParkName, 10) }}</span>
                                                <span v-else>{{ item.nvcParkName }}</span>
                                            </router-link>
                                            <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                            <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                        </div>
                                        <div class="color9">
                                            <span class="fl">
                                                <i class="iconfont icon-fuwuleixing"></i>
                                                {{ item.nvcParkServiceType }}
                                            </span>
                                            <span class="fr">
                                                <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                {{ item.nvcParkTotalArea }}亩
                                            </span>
                                        </div>
                                        <div class="color9">
                                            <i class="iconfont icon-diqu f14"></i>
                                            <span
                                                v-if="
                          item.nvcParkAddress !== null &&
                          item.nvcParkAddress.length > 12
                        "
                                                :title="item.nvcParkAddress"
                                            >{{ commJs.limitNum(item.nvcParkAddress, 12) }}</span>
                                            <span v-else>{{ item.nvcParkAddress }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="商贸型" name="third" v-if="ParkList2.length > 0">
                            <div class="t_img_li">
                                <ul>
                                    <li v-for="item in ParkList2" :key="item.iPrIdentifier">
                                        <router-link
                                            :to="{
                        name: 'logisticsparkdetails',
                        query: {
                          roomid: item.iUiIdentifier,
                          detailid: item.iPrIdentifier,
                        },
                      }"
                                            class="position_rel"
                                        >
                                            <div v-if="
                          item.imgUrlList !== null && item.imgUrlList.length > 0
                        ">
                                                <template v-for="(ite, index2) in item.imgUrlList">
                                                    <el-image
                                                        style="
                              width: 220px;
                              height: 220px;
                              background: #fbfbfb;
                            "
                                                        :src="ite.nvcImage"
                                                        :fit="fit"
                                                        :alt="item.nvcParkName"
                                                        :key="index2"
                                                        v-if="index2 == 0"
                                                    ></el-image>
                                                </template>
                                            </div>
                                            <div v-else>
                                                <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                            </div>
                                            <div class="t_tjimg">
                                                <img src="/static/images/tj_icon.png" />
                                            </div>
                                        </router-link>
                                        <div class="color9 mt10">
                                            <router-link
                                                :to="{
                          name: 'logisticsparkdetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iPrIdentifier,
                          },
                        }"
                                                class="f16 color3"
                                            >
                                                <span
                                                    v-if="
                            item.nvcParkName !== null &&
                            item.nvcParkName.length > 10
                          "
                                                    :title="item.nvcParkName"
                                                >{{ commJs.limitNum(item.nvcParkName, 10) }}</span>
                                                <span v-else>{{ item.nvcParkName }}</span>
                                            </router-link>
                                            <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                            <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                        </div>
                                        <div class="color9">
                                            <span class="fl">
                                                <i class="iconfont icon-fuwuleixing"></i>
                                                {{ item.nvcParkServiceType }}
                                            </span>
                                            <span class="fr">
                                                <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                {{ item.nvcParkTotalArea }}亩
                                            </span>
                                        </div>
                                        <div class="color9">
                                            <i class="iconfont icon-diqu f14"></i>
                                            <span
                                                v-if="
                          item.nvcParkAddress !== null &&
                          item.nvcParkAddress.length > 12
                        "
                                                :title="item.nvcParkAddress"
                                            >{{ commJs.limitNum(item.nvcParkAddress, 12) }}</span>
                                            <span v-else>{{ item.nvcParkAddress }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="综合型" name="fourth" v-if="ParkList3.length > 0">
                            <div class="t_img_li">
                                <ul>
                                    <li v-for="item in ParkList3" :key="item.iPrIdentifier">
                                        <router-link
                                            :to="{
                        name: 'logisticsparkdetails',
                        query: {
                          roomid: item.iUiIdentifier,
                          detailid: item.iPrIdentifier,
                        },
                      }"
                                            class="position_rel"
                                        >
                                            <div v-if="
                          item.imgUrlList !== null && item.imgUrlList.length > 0
                        ">
                                                <template v-for="(ite, index2) in item.imgUrlList">
                                                    <el-image
                                                        style="
                              width: 220px;
                              height: 220px;
                              background: #fbfbfb;
                            "
                                                        :src="ite.nvcImage"
                                                        :fit="fit"
                                                        :alt="item.nvcParkName"
                                                        :key="index2"
                                                        v-if="index2 == 0"
                                                    ></el-image>
                                                </template>
                                            </div>
                                            <div v-else>
                                                <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                            </div>
                                            <div class="t_tjimg">
                                                <img src="/static/images/tj_icon.png" />
                                            </div>
                                        </router-link>
                                        <div class="color9 mt10">
                                            <router-link
                                                :to="{
                          name: 'logisticsparkdetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iPrIdentifier,
                          },
                        }"
                                                class="f16 color3"
                                            >
                                                <span
                                                    v-if="
                            item.nvcParkName !== null &&
                            item.nvcParkName.length > 10
                          "
                                                    :title="item.nvcParkName"
                                                >{{ commJs.limitNum(item.nvcParkName, 10) }}</span>
                                                <span v-else>{{ item.nvcParkName }}</span>
                                            </router-link>
                                            <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                            <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                        </div>
                                        <div class="color9">
                                            <span class="fl">
                                                <i class="iconfont icon-fuwuleixing"></i>
                                                {{ item.nvcParkServiceType }}
                                            </span>
                                            <span class="fr">
                                                <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                {{ item.nvcParkTotalArea }}亩
                                            </span>
                                        </div>
                                        <div class="color9">
                                            <i class="iconfont icon-diqu f14"></i>
                                            <span
                                                v-if="
                          item.nvcParkAddress !== null &&
                          item.nvcParkAddress.length > 12
                        "
                                                :title="item.nvcParkAddress"
                                            >{{ commJs.limitNum(item.nvcParkAddress, 12) }}</span>
                                            <span v-else>{{ item.nvcParkAddress }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="保税型" name="fiveth" v-if="ParkList4.length > 0">
                            <div class="t_img_li">
                                <ul>
                                    <li v-for="item in ParkList4" :key="item.iPrIdentifier">
                                        <router-link
                                            :to="{
                        name: 'logisticsparkdetails',
                        query: {
                          roomid: item.iUiIdentifier,
                          detailid: item.iPrIdentifier,
                        },
                      }"
                                            class="position_rel"
                                        >
                                            <div v-if="
                          item.imgUrlList !== null && item.imgUrlList.length > 0
                        ">
                                                <template v-for="(ite, index2) in item.imgUrlList">
                                                    <el-image
                                                        style="
                              width: 220px;
                              height: 220px;
                              background: #fbfbfb;
                            "
                                                        :src="ite.nvcImage"
                                                        :fit="fit"
                                                        :alt="item.nvcParkName"
                                                        :key="index2"
                                                        v-if="index2 == 0"
                                                    ></el-image>
                                                </template>
                                            </div>
                                            <div v-else>
                                                <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                            </div>
                                            <div class="t_tjimg">
                                                <img src="/static/images/tj_icon.png" />
                                            </div>
                                        </router-link>
                                        <div class="color9 mt10">
                                            <router-link
                                                :to="{
                          name: 'logisticsparkdetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iPrIdentifier,
                          },
                        }"
                                                class="f16 color3"
                                            >
                                                <span
                                                    v-if="
                            item.nvcParkName !== null &&
                            item.nvcParkName.length > 10
                          "
                                                    :title="item.nvcParkName"
                                                >{{ commJs.limitNum(item.nvcParkName, 10) }}</span>
                                                <span v-else>{{ item.nvcParkName }}</span>
                                            </router-link>
                                            <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                            <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                        </div>
                                        <div class="color9">
                                            <span class="fl">
                                                <i class="iconfont icon-fuwuleixing"></i>
                                                {{ item.nvcParkServiceType }}
                                            </span>
                                            <span class="fr">
                                                <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                {{ item.nvcParkTotalArea }}亩
                                            </span>
                                        </div>
                                        <div class="color9">
                                            <i class="iconfont icon-diqu f14"></i>
                                            <span
                                                v-if="
                          item.nvcParkAddress !== null &&
                          item.nvcParkAddress.length > 12
                        "
                                                :title="item.nvcParkAddress"
                                            >{{ commJs.limitNum(item.nvcParkAddress, 12) }}</span>
                                            <span v-else>{{ item.nvcParkAddress }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
        <div id="storage">
            <div class="w1200 mt20 bgwhite clear">
                <div class="plr17 position_rel">
                    <div class="t_tle">
                        <i class="title_icon fl"></i>
                        <span class="f20 color3 fl">{{ comUrl.nodeCity.name }}仓储物流</span>
                        <router-link :to="{ name: 'logisticswarehouse', query: { wareId: warid } }" class="f12 color9 fr" v-if="showwaremore">
                            更多
                            <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                        </router-link>
                        <div class="fr mr15 sebox">
                            <el-form ref="form" :model="form">
                                <el-form-item>
                                    <el-col class="ht32 w320">
                                        <el-input v-model="form.name" placeholder="请输入仓库名称关键字"></el-input>
                                    </el-col>
                                    <el-col class="ht30 w65 ml5">
                                        <el-button type="primary" @click="jumpPath('logisticswarehouse', form.name)" class="orang_button ht30 w65">搜索</el-button>
                                    </el-col>
                                    <el-col class="ht30 w80 ml10 mr18 blue">
                                        <span v-if="isshowit === 'true'">
                                            <router-link :to="{ name: 'parkpublished' }" class="orang_button ht30 w80 show center bg_blue">我要发布</router-link>
                                        </span>
                                        <span v-else>
                                            <router-link :to="{ name: 'login' }" class="orang_button ht30 w80 show center bg_blue">我要发布</router-link>
                                        </span>
                                    </el-col>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <el-tabs v-model="activeName2" @tab-click="handleClick">
                        <el-tab-pane label="全部" name="first">
                            <div class="t_img_li">
                                <ul>
                                    <li v-for="item in WarehouseList" :key="item.iWrIdentifier">
                                        <router-link
                                            :to="{
                        name: 'logisticsstoragedetails',
                        query: {
                          roomid: item.iUiIdentifier,
                          detailid: item.iWrIdentifier,
                        },
                      }"
                                            class="position_rel"
                                        >
                                            <div v-if="
                          item.imgUrlList !== null && item.imgUrlList.length > 0
                        ">
                                                <template v-for="(ite, index2) in item.imgUrlList">
                                                    <el-image
                                                        style="
                              width: 220px;
                              height: 220px;
                              background: #fbfbfb;
                            "
                                                        :src="ite.nvcImage"
                                                        :fit="fit"
                                                        :alt="item.nvcTitle"
                                                        :key="index2"
                                                        v-if="index2 == 0"
                                                    ></el-image>
                                                </template>
                                            </div>
                                            <div v-else>
                                                <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                            </div>
                                            <div class="t_tjimg">
                                                <img src="/static/images/tj_icon.png" />
                                            </div>
                                        </router-link>
                                        <div class="color9 mt10">
                                            <router-link
                                                :to="{
                          name: 'logisticsstoragedetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iWrIdentifier,
                          },
                        }"
                                                class="f16 color3"
                                            >
                                                <span
                                                    v-if="
                            item.nvcTitle !== null && item.nvcTitle.length > 10
                          "
                                                    :title="item.nvcTitle"
                                                >{{ commJs.limitNum(item.nvcTitle, 10) }}</span>
                                                <span v-else>{{ item.nvcTitle }}</span>
                                            </router-link>
                                            <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                            <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                        </div>
                                        <div class="color9">
                                            <span class="fl">
                                                <i class="iconfont icon-jiage"></i>
                                                <span class="color_sub" v-if="item.dRent != '' && item.dRent != null">{{ item.dRent }} 元/㎡/天</span>
                                                <span class="color_sub" v-else>电议</span>
                                            </span>
                                            <span class="fr">
                                                <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                {{ item.dWarehouseArea }}㎡
                                            </span>
                                        </div>
                                        <div class="color9">
                                            <i class="iconfont icon-diqu f14"></i>
                                            <span
                                                v-if="
                          item.nvcWarehouseSourceAddress !== null &&
                          item.nvcWarehouseSourceAddress.length > 12
                        "
                                                :title="item.nvcWarehouseSourceAddress"
                                            >
                                                {{
                                                commJs.limitNum(item.nvcWarehouseSourceAddress, 12)
                                                }}
                                            </span>
                                            <span v-else>{{ item.nvcWarehouseSourceAddress }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="标准库" name="firstd" v-if="WarehouseList6.length > 0">
                            <div class="t_img_li">
                                <ul>
                                    <li v-for="item in WarehouseList6" :key="item.iWrIdentifier">
                                        <router-link
                                            :to="{
                        name: 'logisticsstoragedetails',
                        query: {
                          roomid: item.iUiIdentifier,
                          detailid: item.iWrIdentifier,
                        },
                      }"
                                            class="position_rel"
                                        >
                                            <div v-if="
                          item.imgUrlList !== null && item.imgUrlList.length > 0
                        ">
                                                <template v-for="(ite, index2) in item.imgUrlList">
                                                    <el-image
                                                        style="
                              width: 220px;
                              height: 220px;
                              background: #fbfbfb;
                            "
                                                        :src="ite.nvcImage"
                                                        :fit="fit"
                                                        :alt="item.nvcTitle"
                                                        :key="index2"
                                                        v-if="index2 == 0"
                                                    ></el-image>
                                                </template>
                                            </div>
                                            <div v-else>
                                                <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                            </div>
                                            <div class="t_tjimg">
                                                <img src="/static/images/tj_icon.png" />
                                            </div>
                                        </router-link>
                                        <div class="color9 mt10">
                                            <router-link
                                                :to="{
                          name: 'logisticsstoragedetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iWrIdentifier,
                          },
                        }"
                                                class="f16 color3"
                                            >
                                                <span
                                                    v-if="
                            item.nvcTitle !== null && item.nvcTitle.length > 10
                          "
                                                    :title="item.nvcTitle"
                                                >{{ commJs.limitNum(item.nvcTitle, 12) }}</span>
                                                <span v-else>{{ item.nvcTitle }}</span>
                                            </router-link>
                                            <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                            <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                        </div>
                                        <div class="color9">
                                            <span class="fl">
                                                <i class="iconfont icon-jiage"></i>
                                                <span class="color_sub" v-if="item.dRent != '' && item.dRent != null">{{ item.dRent }} 元/㎡/天</span>
                                                <span class="color_sub" v-else>电议</span>
                                            </span>
                                            <span class="fr">
                                                <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                {{ item.dWarehouseArea }}㎡
                                            </span>
                                        </div>
                                        <div class="color9">
                                            <i class="iconfont icon-diqu f14"></i>
                                            <span
                                                v-if="
                          item.nvcWarehouseSourceAddress !== null &&
                          item.nvcWarehouseSourceAddress.length > 12
                        "
                                                :title="item.nvcWarehouseSourceAddress"
                                            >
                                                {{
                                                commJs.limitNum(item.nvcWarehouseSourceAddress, 12)
                                                }}
                                            </span>
                                            <span v-else>{{ item.nvcWarehouseSourceAddress }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="恒温库" name="second" v-if="WarehouseList1.length > 0">
                            <div class="t_img_li">
                                <ul>
                                    <template v-if="WarehouseList1.length > 0">
                                        <li v-for="item in WarehouseList1" :key="item.iWrIdentifier">
                                            <router-link
                                                :to="{
                          name: 'logisticsstoragedetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iWrIdentifier,
                          },
                        }"
                                                class="position_rel"
                                            >
                                                <div v-if="
                            item.imgUrlList !== null &&
                            item.imgUrlList.length > 0
                          ">
                                                    <template v-for="(ite, index2) in item.imgUrlList">
                                                        <el-image
                                                            style="
                                width: 220px;
                                height: 220px;
                                background: #fbfbfb;
                              "
                                                            :src="ite.nvcImage"
                                                            :fit="fit"
                                                            :alt="item.nvcTitle"
                                                            :key="index2"
                                                            v-if="index2 == 0"
                                                        ></el-image>
                                                    </template>
                                                </div>
                                                <div v-else>
                                                    <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                                </div>
                                                <div class="t_tjimg">
                                                    <img src="/static/images/tj_icon.png" />
                                                </div>
                                            </router-link>
                                            <div class="color9 mt10">
                                                <router-link
                                                    :to="{
                            name: 'logisticsstoragedetails',
                            query: {
                              roomid: item.iUiIdentifier,
                              detailid: item.iWrIdentifier,
                            },
                          }"
                                                    class="f16 color3"
                                                >
                                                    <span
                                                        v-if="
                              item.nvcTitle !== null &&
                              item.nvcTitle.length > 10
                            "
                                                        :title="item.nvcTitle"
                                                    >{{ commJs.limitNum(item.nvcTitle, 10) }}</span>
                                                    <span v-else>{{ item.nvcTitle }}</span>
                                                </router-link>
                                                <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                                <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                            </div>
                                            <div class="color9">
                                                <span class="fl">
                                                    <i class="iconfont icon-jiage"></i>
                                                    <span class="color_sub" v-if="item.dRent != '' && item.dRent != null">{{ item.dRent }} 元/㎡/天</span>
                                                    <span class="color_sub" v-else>电议</span>
                                                </span>
                                                <span class="fr">
                                                    <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                    {{ item.dWarehouseArea }}㎡
                                                </span>
                                            </div>
                                            <div class="color9">
                                                <i class="iconfont icon-diqu f14"></i>
                                                <span
                                                    v-if="
                            item.nvcWarehouseSourceAddress !== null &&
                            item.nvcWarehouseSourceAddress.length > 12
                          "
                                                    :title="item.nvcWarehouseSourceAddress"
                                                >
                                                    {{
                                                    commJs.limitNum(item.nvcWarehouseSourceAddress, 12)
                                                    }}
                                                </span>
                                                <span v-else>{{ item.nvcWarehouseSourceAddress }}</span>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="冷库" name="third" v-if="WarehouseList2.length > 0">
                            <div class="t_img_li">
                                <ul>
                                    <template v-if="WarehouseList2.length > 0">
                                        <li v-for="item in WarehouseList2" :key="item.iWrIdentifier">
                                            <router-link
                                                :to="{
                          name: 'logisticsstoragedetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iWrIdentifier,
                          },
                        }"
                                                class="position_rel"
                                            >
                                                <div v-if="
                            item.imgUrlList !== null &&
                            item.imgUrlList.length > 0
                          ">
                                                    <template v-for="(ite, index2) in item.imgUrlList">
                                                        <el-image
                                                            style="
                                width: 220px;
                                height: 220px;
                                background: #fbfbfb;
                              "
                                                            :src="ite.nvcImage"
                                                            :fit="fit"
                                                            :alt="item.nvcTitle"
                                                            :key="index2"
                                                            v-if="index2 == 0"
                                                        ></el-image>
                                                    </template>
                                                </div>
                                                <div v-else>
                                                    <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                                </div>
                                                <div class="t_tjimg">
                                                    <img src="/static/images/tj_icon.png" />
                                                </div>
                                            </router-link>
                                            <div class="color9 mt10">
                                                <router-link
                                                    :to="{
                            name: 'logisticsstoragedetails',
                            query: {
                              roomid: item.iUiIdentifier,
                              detailid: item.iWrIdentifier,
                            },
                          }"
                                                    class="f16 color3"
                                                >
                                                    <span
                                                        v-if="
                              item.nvcTitle !== null &&
                              item.nvcTitle.length > 10
                            "
                                                        :title="item.nvcTitle"
                                                    >{{ commJs.limitNum(item.nvcTitle, 10) }}</span>
                                                    <span v-else>{{ item.nvcTitle }}</span>
                                                </router-link>
                                                <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                                <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                            </div>
                                            <div class="color9">
                                                <span class="fl">
                                                    <i class="iconfont icon-jiage"></i>
                                                    <span class="color_sub" v-if="item.dRent != '' && item.dRent != null">{{ item.dRent }} 元/㎡/天</span>
                                                    <span class="color_sub" v-else>电议</span>
                                                </span>
                                                <span class="fr">
                                                    <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                    {{ item.dWarehouseArea }}㎡
                                                </span>
                                            </div>
                                            <div class="color9">
                                                <i class="iconfont icon-diqu f14"></i>
                                                <span
                                                    v-if="
                            item.nvcWarehouseSourceAddress !== null &&
                            item.nvcWarehouseSourceAddress.length > 12
                          "
                                                    :title="item.nvcWarehouseSourceAddress"
                                                >
                                                    {{
                                                    commJs.limitNum(item.nvcWarehouseSourceAddress, 12)
                                                    }}
                                                </span>
                                                <span v-else>{{ item.nvcWarehouseSourceAddress }}</span>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="保税库" name="fourth" v-if="WarehouseList3.length > 0">
                            <div class="t_img_li">
                                <ul>
                                    <template v-if="WarehouseList3.length > 0">
                                        <li v-for="item in WarehouseList3" :key="item.iWrIdentifier">
                                            <router-link
                                                :to="{
                          name: 'logisticsstoragedetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iWrIdentifier,
                          },
                        }"
                                                class="position_rel"
                                            >
                                                <div v-if="
                            item.imgUrlList !== null &&
                            item.imgUrlList.length > 0
                          ">
                                                    <template v-for="(ite, index2) in item.imgUrlList">
                                                        <el-image
                                                            style="
                                width: 220px;
                                height: 220px;
                                background: #fbfbfb;
                              "
                                                            :src="ite.nvcImage"
                                                            :fit="fit"
                                                            :alt="item.nvcTitle"
                                                            :key="index2"
                                                            v-if="index2 == 0"
                                                        ></el-image>
                                                    </template>
                                                </div>
                                                <div v-else>
                                                    <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                                </div>
                                                <div class="t_tjimg">
                                                    <img src="/static/images/tj_icon.png" />
                                                </div>
                                            </router-link>
                                            <div class="color9 mt10">
                                                <router-link
                                                    :to="{
                            name: 'logisticsstoragedetails',
                            query: {
                              roomid: item.iUiIdentifier,
                              detailid: item.iWrIdentifier,
                            },
                          }"
                                                    class="f16 color3"
                                                >
                                                    <span
                                                        v-if="
                              item.nvcTitle !== null &&
                              item.nvcTitle.length > 10
                            "
                                                        :title="item.nvcTitle"
                                                    >{{ commJs.limitNum(item.nvcTitle, 10) }}</span>
                                                    <span v-else>{{ item.nvcTitle }}</span>
                                                </router-link>
                                                <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                                <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                            </div>
                                            <div class="color9">
                                                <span class="fl">
                                                    <i class="iconfont icon-jiage"></i>
                                                    <span class="color_sub" v-if="item.dRent != '' && item.dRent != null">{{ item.dRent }} 元/㎡/天</span>
                                                    <span class="color_sub" v-else>电议</span>
                                                </span>
                                                <span class="fr">
                                                    <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                    {{ item.dWarehouseArea }}㎡
                                                </span>
                                            </div>
                                            <div class="color9">
                                                <i class="iconfont icon-diqu f14"></i>
                                                <span
                                                    v-if="
                            item.nvcWarehouseSourceAddress !== null &&
                            item.nvcWarehouseSourceAddress.length > 12
                          "
                                                    :title="item.nvcWarehouseSourceAddress"
                                                >
                                                    {{
                                                    commJs.limitNum(item.nvcWarehouseSourceAddress, 12)
                                                    }}
                                                </span>
                                                <span v-else>{{ item.nvcWarehouseSourceAddress }}</span>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="危险品库" name="fiveth" v-if="WarehouseList4.length > 0">
                            <div class="t_img_li">
                                <ul>
                                    <template v-if="WarehouseList4.length > 0">
                                        <li v-for="item in WarehouseList4" :key="item.iWrIdentifier">
                                            <router-link
                                                :to="{
                          name: 'logisticsstoragedetails',
                          query: {
                            roomid: item.iUiIdentifier,
                            detailid: item.iWrIdentifier,
                          },
                        }"
                                                class="position_rel"
                                            >
                                                <div v-if="
                            item.imgUrlList !== null &&
                            item.imgUrlList.length > 0
                          ">
                                                    <template v-for="(ite, index2) in item.imgUrlList">
                                                        <el-image
                                                            style="
                                width: 220px;
                                height: 220px;
                                background: #fbfbfb;
                              "
                                                            :src="ite.nvcImage"
                                                            :fit="fit"
                                                            :alt="item.nvcTitle"
                                                            :key="index2"
                                                            v-if="index2 == 0"
                                                        ></el-image>
                                                    </template>
                                                </div>
                                                <div v-else>
                                                    <el-image style="width: 220px; height: 220px" src="./static/images/nnopic.png" :fit="fit"></el-image>
                                                </div>
                                                <div class="t_tjimg">
                                                    <img src="/static/images/tj_icon.png" />
                                                </div>
                                            </router-link>
                                            <div class="color9 mt10">
                                                <router-link
                                                    :to="{
                            name: 'logisticsstoragedetails',
                            query: {
                              roomid: item.iUiIdentifier,
                              detailid: item.iWrIdentifier,
                            },
                          }"
                                                    class="f16 color3"
                                                >
                                                    <span
                                                        v-if="
                              item.nvcTitle !== null &&
                              item.nvcTitle.length > 10
                            "
                                                        :title="item.nvcTitle"
                                                    >{{ commJs.limitNum(item.nvcTitle, 10) }}</span>
                                                    <span v-else>{{ item.nvcTitle }}</span>
                                                </router-link>
                                                <el-image v-if="item.iMemberType == '37'" src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px" class="ml5"></el-image>
                                                <el-image v-if="item.iMemberType == '38'" src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px" class="ml5"></el-image>
                                            </div>
                                            <div class="color9">
                                                <span class="fl">
                                                    <i class="iconfont icon-jiage"></i>
                                                    <span class="color_sub" v-if="item.dRent != '' && item.dRent != null">{{ item.dRent }} 元/㎡/天</span>
                                                    <span class="color_sub" v-else>电议</span>
                                                </span>
                                                <span class="fr">
                                                    <i class="iconfont icon-gengxinzuocaidanlan__cangku"></i>
                                                    {{ item.dWarehouseArea }}㎡
                                                </span>
                                            </div>
                                            <div class="color9">
                                                <i class="iconfont icon-diqu f14"></i>
                                                <span
                                                    v-if="
                            item.nvcWarehouseSourceAddress !== null &&
                            item.nvcWarehouseSourceAddress.length > 12
                          "
                                                    :title="item.nvcWarehouseSourceAddress"
                                                >
                                                    {{
                                                    commJs.limitNum(item.nvcWarehouseSourceAddress, 12)
                                                    }}
                                                </span>
                                                <span v-else>{{ item.nvcWarehouseSourceAddress }}</span>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
        <div id="line">
            <div class="w1200 mt20 clear">
                <div class="bgwhite plr17 w896 fl">
                    <div class="t_tle">
                        <i class="title_icon fl"></i>
                        <span class="f20 color3 fl">{{ comUrl.nodeCity.name }}物流专线</span>
                        <router-link :to="{ name: 'logisticsline' }" class="f12 color9 fr" v-if="DedicatedList.length == 5">
                            更多
                            <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                        </router-link>
                        <div class="fr mr15 sebox">
                            <el-form ref="form" :model="form">
                                <el-form-item>
                                    <el-col class="ht32 w200 index-select">
                                        <!-- <el-input v-model="form.linestart" placeholder="请输入装货地关键字"></el-input> -->
                                        <el-cascader v-model="form.linestart" :options="options" :props="{ expandTrigger: 'hover', checkStrictly: true }" placeholder="请选择始发地" @change="handleChange"></el-cascader>
                                    </el-col>
                                    <el-col class="ml5 ht32 w200 index-select">
                                        <!-- <el-input v-model="form.lineend" placeholder="请输入卸货地关键字"></el-input> -->
                                        <el-cascader v-model="form.lineend" :options="options" :props="{ expandTrigger: 'hover', checkStrictly: true }" placeholder="请选择目的地" @change="handleChange"></el-cascader>
                                    </el-col>
                                    <el-col class="ht30 w65 ml5">
                                        <el-button
                                            type="primary"
                                            @click="
                        jumpPath2('logisticsline', form.linestart, form.lineend)
                      "
                                            class="orang_button ht30 w65"
                                        >搜索</el-button>
                                    </el-col>
                                    <el-col class="ht30 w80 ml10 mr18 blue">
                                        <span v-if="isshowit === 'true'">
                                            <router-link :to="{ name: 'linepublished' }" class="orang_button ht30 w80 show center bg_blue">我要发布</router-link>
                                        </span>
                                        <span v-else>
                                            <router-link :to="{ name: 'login' }" class="orang_button ht30 w80 show center bg_blue">我要发布</router-link>
                                        </span>
                                    </el-col>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="mt5 pb10 index-line">
                        <el-table :data="DedicatedList" style="width: 100%" class="t_table">
                            <el-table-column prop="nvcCompany" label="企业名称" width="310">
                                <template slot-scope="scope">
                                    <router-link
                                        class="nowrap"
                                        :to="{
                      name: 'logisticslinedetails',
                      query: {
                        roomid: scope.row.iUiIdentifier,
                        detailid: scope.row.iDrIdentifier,
                      },
                    }"
                                    >
                                        <img
                                            :src="
                        scope.row.nvcBusinessLogo != null &&
                        scope.row.nvcBusinessLogo != ''
                          ? scope.row.nvcBusinessLogo
                          : './static/images/nnopic.png'
                      "
                                            :alt="
                        scope.row.nvcBusinessLogo != null &&
                        scope.row.nvcBusinessLogo != ''
                          ? scope.row.nvcCompany
                          : ''
                      "
                                            style="width: 42px; height: 42px; margin-right: 5px"
                                        />
                                        <span
                                            :title="
                        scope.row.nvcCompany && scope.row.nvcCompany.length < 17
                          ? false
                          : scope.row.nvcCompany
                      "
                                        >{{ scope.row.nvcCompany }}</span>
                                    </router-link>
                                    <span v-if="scope.row.iMemberType == '37'" class="ml5">
                                        <el-image src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px"></el-image>
                                    </span>
                                    <span v-if="scope.row.iMemberType == '38'" class="ml5">
                                        <el-image src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px"></el-image>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nvcProvinceO,nvcCityNameO,nvcCountyNameO,nvcProvinceD,nvcCityNameD,nvcCountyNameD" label="线路" width="286">
                                <template slot-scope="scope">
                                    <span class="nowrap">
                                        {{ scope.row.nvcProvinceO }}{{ scope.row.nvcCityNameO
                                        }}{{ scope.row.nvcCountyNameO }}
                                        <i
                                            class="iconfont icon-jiantou2 color9 f12"
                                        ></i>
                                        {{ scope.row.nvcProvinceD }}{{ scope.row.nvcCityNameD
                                        }}{{ scope.row.nvcCountyNameD }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nvcTransportType" label="运输类型" width="120" align="center"></el-table-column>
                            <el-table-column prop="nvcPhone" label="联系电话" width="180" align="center">
                                <template slot-scope="scope">
                                    <span v-if="isshowit === 'true'">
                                        {{
                                        scope.row.nvcPhone || "--"
                                        }}
                                    </span>
                                    <span v-else>
                                        <router-link :to="{ name: 'login' }">查看</router-link>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="fr plr14 bgwhite w224 ht412 t_yxline list_ad">
                    <div class="t_tle">
                        <span class="f20 color3">优秀专线推荐</span>
                    </div>
                    <ul>
                        <li>
                            <i>广告</i>
                            <el-image style="width: 224px; height: 100px" src="./static/images/54942.jpg"></el-image>
                        </li>
                        <li>
                            <i>广告</i>
                            <el-image style="width: 224px; height: 100px" src="./static/images/55019.jpg"></el-image>
                        </li>
                        <li>
                            <i>广告</i>
                            <el-image style="width: 224px; height: 100px" src="./static/images/155041.jpg"></el-image>
                        </li>
                    </ul>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <div id="jobs">
            <div class="w1200 mt20 bgwhite clear" v-show="joblist !== null && joblist.length > 0">
                <div class="plr14">
                    <div class="t_tle">
                        <i class="title_icon fl"></i>
                        <span class="f20 color3 fl">{{ comUrl.nodeCity.name }}物流招聘</span>
                        <router-link :to="{ name: 'logisticsjob' }" class="f12 color9 fr" v-if="joblist.length == 5">
                            更多
                            <i class="iconfont icon-arrow-right-copy-copy f12"></i>
                        </router-link>
                        <div class="fr mr15 sebox">
                            <el-form ref="jobform" :model="jobform">
                                <el-form-item>
                                    <el-col class="ht32 w320">
                                        <el-input v-model="jobform.name" placeholder="请输入职位名称关键字"></el-input>
                                    </el-col>
                                    <el-col class="ht30 w65 ml5 mr18">
                                        <el-button type="primary" @click="jumpPath('logisticsjob', jobform.name)" class="orang_button ht30 w65">搜索</el-button>
                                    </el-col>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="mt5 pb10">
                        <el-table :data="joblist" style="width: 100%" class="t_table">
                            <el-table-column prop="nvcJobTitle" label="职位名称" width="230">
                                <template slot-scope="scope">
                                    <router-link
                                        :to="{
                      name: 'jobsdetail',
                      query: {
                        roomid: scope.row.iPublisherId,
                        detailid: scope.row.iUIdentifier,
                      },
                    }"
                                    >{{ scope.row.nvcJobTitle }}</router-link>
                                </template>
                            </el-table-column>
                            <el-table-column prop="iSalaryRange" label="薪资待遇" width="120" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.iSalaryRange == 1">2k以下</span>
                                    <span v-else-if="scope.row.iSalaryRange == 2">2-4k</span>
                                    <span v-else-if="scope.row.iSalaryRange == 3">4-6k</span>
                                    <span v-else-if="scope.row.iSalaryRange == 4">6-8k</span>
                                    <span v-else-if="scope.row.iSalaryRange == 5">8-10k</span>
                                    <span v-else-if="scope.row.iSalaryRange == 6">10-15k</span>
                                    <span v-else-if="scope.row.iSalaryRange == 7">15-20k</span>
                                    <span v-else-if="scope.row.iSalaryRange == 8">20-30k</span>
                                    <span v-else-if="scope.row.iSalaryRange == 9">30k以上</span>
                                    <span v-else-if="scope.row.iSalaryRange == 10">面议</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="iExperienceRequirements" label="经验" width="120" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.iExperienceRequirements == 0">不限</span>
                                    <span v-else-if="scope.row.iExperienceRequirements == 1">1-3年</span>
                                    <span v-else-if="scope.row.iExperienceRequirements == 2">3-5年</span>
                                    <span v-else-if="scope.row.iExperienceRequirements == 3">5-10年</span>
                                    <span v-else-if="scope.row.iExperienceRequirements == 4">10年以上</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="iEducationBackground" label="学历要求" width="120" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.iEducationBackground == 0">不限</span>
                                    <span v-else-if="scope.row.iEducationBackground == 1">初中及以下</span>
                                    <span v-else-if="scope.row.iEducationBackground == 2">中专/技校/高中</span>
                                    <span v-else-if="scope.row.iEducationBackground == 3">大专</span>
                                    <span v-else-if="scope.row.iEducationBackground == 4">本科</span>
                                    <span v-else-if="scope.row.iEducationBackground == 5">硕士</span>
                                    <span v-else-if="scope.row.iEducationBackground == 6">博士</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="iJobNature" label="工作性质" width="120" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.iJobNature == 1">全职</span>
                                    <span v-else-if="scope.row.iJobNature == 2">兼职</span>
                                    <span v-else-if="scope.row.iJobNature == 3">实习</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nvcWorkCounty" label="工作地区" width="220" align="center">
                                <template slot-scope="scope">
                                    <span class="nowrap">
                                        {{
                                        scope.row.nvcWorkCounty
                                        }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nvcCompany" label="招聘企业" width="240">
                                <template slot-scope="scope">
                                    <span
                                        class="nowrap"
                                        v-if="
                      scope.row.nvcCompany !== null &&
                      scope.row.nvcCompany.length > 12
                    "
                                        :title="scope.row.nvcCompany"
                                    >{{ commJs.limitNum(scope.row.nvcCompany, 12) }}</span>
                                    <span class="nowrap" v-else>{{ scope.row.nvcCompany }}</span>
                                    <span v-if="scope.row.iMemberType == '37'" class="ml5">
                                        <el-image src="./static/images/icon_hj.png" title="黄金会员" :fit="fit" style="width: 21px; height: 17px"></el-image>
                                    </span>
                                    <span v-if="scope.row.iMemberType == '38'" class="ml5">
                                        <el-image src="./static/images/icon_vip.png" title="vip会员" :fit="fit" style="width: 18px; height: 17px"></el-image>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="w1200 mt20 bgwhite clear">
            <div class="plr17 position_rel">
                <div class="t_tle">
                    <i class="title_icon fl"></i>
                    <span class="f20 color3 fl">友情链接</span>
                    <div class="clear"></div>
                </div>
                <div class="t_links">
                    <ul>
                        <li v-for="(item, index) in government" :key="index">
                            <a :href="item.nvcUrl" target="_blank">{{ item.nvcTitle }}</a>
                            <span>|</span>
                        </li>
                    </ul>
                </div>
                <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="政府机构" name="first">

          </el-tab-pane>
          <el-tab-pane label="相关协会" name="second">
            <div class="t_links">
              <ul>
                <li v-for="(item,index) in association" :key="index">
                  <a :href="item.nvcUrl" target="_blank">{{item.nvcTitle}}</a>
                  <span>|</span>
                </li>
              </ul>
            </div>
          </el-tab-pane>
          <el-tab-pane label="相关媒体" name="third">
            <div class="t_links">
              <ul>
                <li v-for="(item,index) in media" :key="index">
                  <a :href="item.nvcUrl" target="_blank">{{item.nvcTitle}}</a>
                  <span>|</span>
                </li>
              </ul>
            </div>
          </el-tab-pane>
                </el-tabs>-->
            </div>
        </div>
        <homebottom></homebottom>
        <div class="t_menulist">
            <ul>
                <li @click="getejfl('association')" :class="hoded == '1' ? 't_xzhouer' : ''">物流协会</li>
                <li @click="getejfl('dynamic')" :class="hoded == '2' ? 't_xzhouer' : ''">协会动态</li>
                <li @click="getejfl('dynamic')" :class="hoded == '2' ? 't_xzhouer' : ''">会员动态</li>
                <li @click="getejfl('committee')" v-if="CommitteeList.nvcName" :class="hoded == '3' ? 't_xzhouer' : ''">专委会</li>
                <li @click="getejfl('transaction')" :class="hoded == '5' ? 't_xzhouer' : ''">物流交易</li>
                <li @click="getejfl('park')" :class="hoded == '6' ? 't_xzhouer' : ''">物流园区</li>
                <li @click="getejfl('storage')" :class="hoded == '7' ? 't_xzhouer' : ''">仓储物流</li>
                <li @click="getejfl('line')" :class="hoded == '8' ? 't_xzhouer' : ''">物流专线</li>
                <li @click="getejfl('jobs')" v-show="joblist !== null && joblist.length > 0" :class="hoded == '9' ? 't_xzhouer' : ''">物流招聘</li>
                <li class="t-gotop" @click="getejfl('box')">
                    <i class="iconfont icon-fanhuidingbu"></i>顶部
                </li>
            </ul>
        </div>
        <el-dialog title="提示" :visible.sync="membershow" width="370px">
            <div class="center t_ts_xxll">
                <i class="iconfont icon-gantanhao color_sub f40"></i>
                <br />
                <span>
                    只有
                    <span class="color_sub">会员权限</span>才能查看，升级会员请拨打客服电话！
                </span>
                <br />
                <span class="color_main f16">
                    <i class="iconfont icon-dianhua2"></i>15130295696
                </span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import hometop from "@/components/Public/homeTop";
import fastchannel from "@/components/Public/fastChannel";
import homebottom from "@/components/Public/homeBottom";
import enterteam from "@/components/Public/enterTeam";
export default {
    name: "index",
    data() {
        return {
            isshowit: localStorage.getItem("islogin"),
            username: localStorage.getItem("userName"),
            isvip: "",
            userid: localStorage.getItem("userId"),
            hoded: "",
            theid: "",
            warid: "",
            newslist: [],
            wallmap: [],
            nodeelist: [],
            newsletter: [],
            memberlist: [],
            government: [],
            association: [],
            media: [],
            tabPosition: "left",
            fit: "contain",
            xhjj: {
                logo: "",
                content: "",
            },
            joblist: [],
            jobform: { name: "" },
            form: {
                name: "",
                phone: "",
                desc: "",
                transactionbegin: "",
                transactionend: "",
                parkname: "",
                linestart: "",
                lineend: "",
                url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            },
            activeName: "first",
            activeName1: "first",
            activeName2: "first",
            activeName3: "first",
            activeName4: "",
            fill: "fill",
            SupplyTradeList: [],
            DedicatedList: [],
            WarehouseList: [],
            WarehouseList1: [],
            WarehouseList2: [],
            WarehouseList3: [],
            WarehouseList4: [],
            WarehouseList6: [],
            ParkList: [],
            ParkList1: [],
            ParkList2: [],
            ParkList3: [],
            ParkList4: [],
            ParkList6: [],
            NewsList: [],
            HotNewsList: [],
            CommitteeList: {},
            CommitteeList2: {},
            showparkmore: true,
            showwaremore: true,
            membershow: false,
            options: [], // 省市区三级联动
            showindistry: false, // 行业物流飘窗
            showlogistic: false, // 物流行业飘窗
            showcity: false, // 县区节点飘窗
        };
    },
    components: {
        hometop,
        fastchannel,
        homebottom,
        enterteam,
    },
    filters: {
        formatDate2: function (value) {
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let m = date.getMinutes();
            m = m < 10 ? "0" + m : m;
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s;
            return y + "-" + MM + "-" + d;
        },
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll, true);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll, true);
    },
    methods: {
        loading(msg) {
            this.$message({
                message: msg + "暂未开通",
            });
        },
        getconpany() {
            // 省市区三级联动
            debugger;
            let data = {
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
            };
            this.$axios
                .post("/user/InternalManageService/GetAllAreaNew", data)
                .then((res) => {
                    debugger;
                    console.log(res, "省市区");
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.options = infordata;
                    }
                });
        },
        handleChange(value) {
            console.log(value);
        },
        getMemberType() {
            // 获取登录的会员身份
            let data = {
                iUiIdentifier: this.userid,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
            };
            this.$axios
                .post("/information/ResourcesService/getServicesByUserId", data)
                .then((res) => {
                    console.log(res, "会员");
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.isvip = infordata[0].iSelectService;
                    }
                });
        },
        isvipmember() {
            // vip会员弹出
            this.membershow = true;
        },
        handleScroll(e) {
            var scrollTop = e.srcElement.scrollingElement.scrollTop + 30;
            if (scrollTop < document.getElementById("association").offsetTop) {
                this.hoded = "";
            } else if (
                scrollTop > document.getElementById("association").offsetTop &&
                scrollTop < document.getElementById("dynamic").offsetTop
            ) {
                this.hoded = "1";
            } else if (
                scrollTop > document.getElementById("dynamic").offsetTop &&
                scrollTop < document.getElementById("committee").offsetTop
            ) {
                this.hoded = "2";
            } else if (
                scrollTop > document.getElementById("committee").offsetTop &&
                scrollTop < document.getElementById("transaction").offsetTop
            ) {
                this.hoded = "3";
            } else if (
                scrollTop > document.getElementById("transaction").offsetTop &&
                scrollTop < document.getElementById("park").offsetTop
            ) {
                this.hoded = "5";
            } else if (
                scrollTop > document.getElementById("park").offsetTop &&
                scrollTop < document.getElementById("storage").offsetTop
            ) {
                this.hoded = "6";
            } else if (
                scrollTop > document.getElementById("storage").offsetTop &&
                scrollTop < document.getElementById("line").offsetTop
            ) {
                this.hoded = "7";
            } else if (
                scrollTop > document.getElementById("line").offsetTop &&
                scrollTop < document.getElementById("jobs").offsetTop - 150
            ) {
                this.hoded = "8";
            } else if (
                scrollTop >
                document.getElementById("jobs").offsetTop - 150
            ) {
                this.hoded = "9";
            }
        },
        getejfl(num) {
            document.getElementById(num).scrollIntoView();
        },
        getInformteam() {
            let data = {
                NodeType: this.comUrl.nodeCity.nodeType,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
            };
            console.log(data, "货");
            this.$axios
                .post(
                    "/information/InformationsService/getNodeClientDatas",
                    data
                )
                .then((res) => {
                    console.log(res, "首页");
                    let infordata = res[0];
                    if (infordata[0].SupplyTradeList.length > 0) {
                        this.SupplyTradeList = infordata[0].SupplyTradeList;
                    }
                    if (infordata[0].DedicatedList.length > 0) {
                        infordata[0].DedicatedList.forEach((item) => {
                            if (
                                item.nvcBusinessLogo != null &&
                                item.nvcBusinessLogo != ""
                            ) {
                                if (
                                    item.nvcBusinessLogo.indexOf(
                                        "http://www.560315.com"
                                    ) >= 0
                                ) {
                                    item.nvcBusinessLogo =
                                        item.nvcBusinessLogo.replace(
                                            "http://www.560315.com",
                                            "http://images.560315.com"
                                        );
                                } else if (
                                    item.nvcBusinessLogo.indexOf(
                                        "/Content/Web/UploadFiles"
                                    ) == 0
                                ) {
                                    item.nvcBusinessLogo =
                                        "http://images.560315.com" +
                                        item.nvcBusinessLogo;
                                }
                            }
                        });
                        this.DedicatedList = infordata[0].DedicatedList;
                    }
                    if (infordata[0].WarehouseList.length > 0) {
                        this.WarehouseList = infordata[0].WarehouseList;
                    }
                    if (infordata[0].ParkList.length > 0) {
                        this.ParkList = infordata[0].ParkList;
                    }
                    if (infordata[0].NewsList.length > 0) {
                        this.NewsList = infordata[0].NewsList;
                    }
                    if (infordata[0].HotNewsList.length > 0) {
                        this.HotNewsList = infordata[0].HotNewsList;
                    }
                    if (infordata[0].AccociationNewsList.length > 0) {
                        this.newsletter = infordata[0].AccociationNewsList;
                    }
                    if (infordata[0].UserNewsList.length > 0) {
                        this.memberlist = infordata[0].UserNewsList;
                    }

                    if (infordata[0].CommitteeList.length > 0) {
                        this.CommitteeList = infordata[0].CommitteeList[0];
                        console.log(this.CommitteeList, "行业协会");
                        if (infordata[0].CommitteeList.length > 1) {
                            this.CommitteeList2 = infordata[0].CommitteeList[1];
                        }
                    }
                });
        },
        wantJoin(num) {
            this.$layer.iframe({
                content: {
                    content: enterteam, // 传递的组件对象
                    parent: this, // 当前的vue对象
                    data: { num: num }, // props
                },
                area: ["500px", ""],
                title: "我要入驻",
            });
        },
        closeAll() {
            this.$layer.closeAll();
        },
        handleClick(tab, event) {
            console.log(tab, event);
            console.log(this.activeName1);
            if (this.activeName1 == "first") {
                this.theid = "";
                if (this.ParkList.length == 5) {
                    this.showparkmore = true;
                } else {
                    this.showparkmore = false;
                }
            } else if (this.activeName1 == "firstd") {
                this.theid = 1;
                if (this.ParkList6.length == 5) {
                    this.showparkmore = true;
                } else {
                    this.showparkmore = false;
                }
            } else if (this.activeName1 == "second") {
                this.theid = 2;
                if (this.ParkList1.length == 5) {
                    this.showparkmore = true;
                } else {
                    this.showparkmore = false;
                }
            } else if (this.activeName1 == "third") {
                this.theid = 3;
                if (this.ParkList2.length == 5) {
                    this.showparkmore = true;
                } else {
                    this.showparkmore = false;
                }
            } else if (this.activeName1 == "fourth") {
                this.theid = 4;
                if (this.ParkList3.length == 5) {
                    this.showparkmore = true;
                } else {
                    this.showparkmore = false;
                }
            } else if (this.activeName1 == "fiveth") {
                this.theid = 5;
                if (this.ParkList4.length == 5) {
                    this.showparkmore = true;
                } else {
                    this.showparkmore = false;
                }
            }
            switch (this.activeName2) {
                case "first":
                    this.warid = "";
                    if (this.WarehouseList.length == 5) {
                        this.showwaremore = true;
                    } else {
                        this.showwaremore = false;
                    }
                    break;
                case "firstd":
                    this.warid = 1;
                    if (this.WarehouseList6.length == 5) {
                        this.showwaremore = true;
                    } else {
                        this.showwaremore = false;
                    }
                    break;
                case "second":
                    this.warid = 2;
                    if (this.WarehouseList1.length == 5) {
                        this.showwaremore = true;
                    } else {
                        this.showwaremore = false;
                    }
                    break;
                case "third":
                    this.warid = 3;
                    if (this.WarehouseList2.length == 5) {
                        this.showwaremore = true;
                    } else {
                        this.showwaremore = false;
                    }
                    break;
                case "fourth":
                    this.warid = 4;
                    if (this.WarehouseList3.length == 5) {
                        this.showwaremore = true;
                    } else {
                        this.showwaremore = false;
                    }
                    break;
                case "fiveth":
                    this.warid = 5;
                    if (this.WarehouseList4.length == 5) {
                        this.showwaremore = true;
                    } else {
                        this.showwaremore = false;
                    }
                    break;
            }
        },
        openView() {
            if (this.activeName3 == "first") {
                this.$router.push({ name: "logisticsnews" });
            } else {
                this.$router.push({
                    name: "dynamic",
                });
            }
        },
        getWallMap() {
            // 挂图
            let data = {
                isFrontDisplay: true,
                resourcePlatform: this.comUrl.nodeCity.Platform,
            };
            this.$axios
                .post("/information/ResourcesService/getPlatformImg", data)
                .then((res) => {
                    console.log(res);
                    if (res[0].length > 0) {
                        let infordata = res[0];
                        if (infordata.length > 0) {
                            this.wallmap = infordata;
                            this.activeName4 = this.commJs.getString(
                                infordata[0].iPiIdentifier
                            );
                        }
                    }
                });
        },
        getIndustry() {
            let data = {
                nvcResourceplatform: this.comUrl.nodeCity.resourcePlatform,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                iType:
                    this.comUrl.nodeCity.resourcePlatform ==
                    this.comUrl.nodeCity.Platform
                        ? "2"
                        : "1",
                iCoIdentifier:
                    this.comUrl.nodeCity.resourcePlatform ==
                    this.comUrl.nodeCity.Platform
                        ? ""
                        : this.comUrl.nodeCity.resourcePlatform,
            };
            this.$axios
                .post(
                    "/information/AssociationService/getAssociationNodeList",
                    data
                )
                .then((res) => {
                    if (res[0].length > 0) {
                        let infordata = res[0];
                        if (infordata[0].nvcContent != null) {
                            if (infordata[0].nvcContent.length > 320) {
                                this.xhjj.content = this.commJs.limitNum(
                                    this.commJs.removeLab(
                                        infordata[0].nvcContent
                                    ),
                                    320
                                );
                            } else {
                                this.xhjj.content = this.commJs.removeLab(
                                    infordata[0].nvcContent
                                );
                            }
                        }
                        this.xhjj.logo = infordata[0].nvcAssociationLogo;
                        console.log(this.xhjj.logo, "logo");
                    }
                });
        },
        getnodelist() {
            // 县区节点
            let data = {
                iType: 1,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                nvcResourcePlatform: this.comUrl.nodeCity.resourcePlatform,
            };

            this.$axios
                .post(
                    "/information/AssociationService/getAssociationNodeList",
                    data
                )
                .then((res) => {
                    console.log(res, "地图");
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.nodeelist = infordata;
                    }
                });
        },
        getlinklist() {
            // 友情链接政府
            let data = {
                isPage: false,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                nvcResourceNode: this.comUrl.nodeCity.resourcePlatform,
            };
            this.$axios
                .post(
                    "/information/InformationsService/getFriendLinkList",
                    data
                )
                .then((res) => {
                    console.log(res);
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.government = infordata;
                    }
                });
        },
        getlinklistxh() {
            // 友情链接协会
            let data = {
                iType: 2,
                isPage: false,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                nvcResourceNode: this.comUrl.nodeCity.resourcePlatform,
            };
            this.$axios
                .post(
                    "/information/InformationsService/getFriendLinkList",
                    data
                )
                .then((res) => {
                    console.log(res);
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.association = infordata;
                    }
                });
        },
        getlinklistmt() {
            // 友情链接媒体
            let data = {
                iType: 3,
                isPage: false,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                nvcResourceNode: this.comUrl.nodeCity.resourcePlatform,
            };
            this.$axios
                .post(
                    "/information/InformationsService/getFriendLinkList",
                    data
                )
                .then((res) => {
                    console.log(res);
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.media = infordata;
                    }
                });
        },
        getJobs() {
            // 获取招聘列表
            let data = {
                iUIdentifier: null,
                isDelete: false,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                nodeType: this.comUrl.nodeCity.nodeType,
                isPage: true,
                size: 5,
                current: 1,
            };
            console.log(data);
            this.$axios
                .post(
                    "/information/ResourceService/getTRecruitmentInformation",
                    data
                )
                .then((res) => {
                    console.log(res, "招聘");
                    if (res[0].length > 0) {
                        let infordata = res[0];
                        this.joblist = infordata;
                    }
                })
                .catch((erro) => {
                    console.log(erro);
                });
        },
        jumpPath(path, para) {
            this.$router.push({
                name: path,
                query: { title: para },
            });
        },
        jumpPath2(path, para1, para2) {
            this.$router.push({
                name: path,
                query: { begin: para1, end: para2 },
            });
        },
        handleClicktwo(event) {
            console.log(event);
            window.open(
                this.comUrl.apiBaseUrl.baseUrl5 +
                    "/Transaction/GTDetails?stid=" +
                    event,
                "_blank"
            );
        },
        getparkInformation6() {
            // 获取园区-货运
            let data = {
                iScIdentifier: 1,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                isPage: true,
                size: 5,
                current: 1,
                isDelete: false,
            };
            console.log(data);
            this.$axios
                .post("/information/ResourceService/gettParkResourceList", data)
                .then((res) => {
                    console.log(res);

                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.ParkList6 = infordata;
                    }
                });
        },
        getparkInformation1() {
            // 获取园区-生产
            let data = {
                iScIdentifier: 2,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                isPage: true,
                size: 5,
                current: 1,
                isDelete: false,
            };
            console.log(data);
            this.$axios
                .post("/information/ResourceService/gettParkResourceList", data)
                .then((res) => {
                    console.log(res);

                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.ParkList1 = infordata;
                    }
                });
        },
        getparkInformation2() {
            // 获取园区-商贸
            let data = {
                iScIdentifier: 3,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                isPage: true,
                size: 5,
                current: 1,
                isDelete: false,
            };
            console.log(data);
            this.$axios
                .post("/information/ResourceService/gettParkResourceList", data)
                .then((res) => {
                    console.log(res);

                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.ParkList2 = infordata;
                    }
                });
        },
        getparkInformation3() {
            // 获取园区-综合
            let data = {
                iScIdentifier: 4,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                isPage: true,
                size: 5,
                current: 1,
                isDelete: false,
            };
            console.log(data);
            this.$axios
                .post("/information/ResourceService/gettParkResourceList", data)
                .then((res) => {
                    console.log(res);

                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.ParkList3 = infordata;
                    }
                });
        },
        getparkInformation4() {
            // 获取园区-保税
            let data = {
                iScIdentifier: 5,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                isPage: true,
                size: 5,
                current: 1,
                isDelete: false,
            };
            console.log(data);
            this.$axios
                .post("/information/ResourceService/gettParkResourceList", data)
                .then((res) => {
                    console.log(res);

                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.ParkList4 = infordata;
                    }
                });
        },
        getWareInformation6() {
            // 获取仓储-标准
            let data = {
                iStIdentifier: 1,
                nvcResourceNode: this.comUrl.nodeCity.resourcePlatform,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                isPage: true,
                size: 5,
                current: 1,
                isDelete: false,
            };
            console.log(data);
            this.$axios
                .post(
                    "/information/ResourceService/getLeaseWarehouseSourceList",
                    data
                )
                .then((res) => {
                    console.log(res);
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.WarehouseList6 = infordata;
                    }
                });
        },
        getWareInformation1() {
            // 获取仓储-恒温
            let data = {
                iStIdentifier: 2,
                nvcResourceNode: this.comUrl.nodeCity.resourcePlatform,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                isPage: true,
                size: 5,
                current: 1,
                isDelete: false,
            };
            console.log(data);
            this.$axios
                .post(
                    "/information/ResourceService/getLeaseWarehouseSourceList",
                    data
                )
                .then((res) => {
                    console.log(res);
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.WarehouseList1 = infordata;
                    }
                });
        },
        getWareInformation2() {
            // 获取仓储-冷库
            let data = {
                iStIdentifier: 3,
                nvcResourceNode: this.comUrl.nodeCity.resourcePlatform,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                isPage: true,
                size: 5,
                current: 1,
                isDelete: false,
            };
            console.log(data);
            this.$axios
                .post(
                    "/information/ResourceService/getLeaseWarehouseSourceList",
                    data
                )
                .then((res) => {
                    console.log(res);
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.WarehouseList2 = infordata;
                    }
                });
        },
        getWareInformation3() {
            // 获取仓储-保税
            let data = {
                iStIdentifier: 4,
                nvcResourceNode: this.comUrl.nodeCity.resourcePlatform,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                isPage: true,
                size: 5,
                current: 1,
                isDelete: false,
            };
            console.log(data);
            this.$axios
                .post(
                    "/information/ResourceService/getLeaseWarehouseSourceList",
                    data
                )
                .then((res) => {
                    console.log(res);
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.WarehouseList3 = infordata;
                    }
                });
        },
        getWareInformation4() {
            // 获取仓储-危险品
            let data = {
                iStIdentifier: 5,
                nvcResourceNode: this.comUrl.nodeCity.resourcePlatform,
                resourcePlatform: this.comUrl.nodeCity.resourcePlatform,
                isPage: true,
                size: 5,
                current: 1,
                isDelete: false,
            };
            console.log(data);
            this.$axios
                .post(
                    "/information/ResourceService/getLeaseWarehouseSourceList",
                    data
                )
                .then((res) => {
                    console.log(res);
                    let infordata = res[0];
                    if (infordata.length > 0) {
                        this.WarehouseList4 = infordata;
                    }
                });
        },
        changeurl(val) {
            let that = this;
            for (let i = 0, leng = this.nodeelist.length; i < leng; i++) {
                if (this.nodeelist[i].nvcNodeName == val) {
                    if (val == "物流开平") {
                        window.open(
                            "http://" + "kaiping." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流路南") {
                        window.open(
                            "http://" + "lunan." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流路北") {
                        window.open(
                            "http://" + "lubei." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流丰润") {
                        window.open(
                            "http://" + "fengrun." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流丰南") {
                        window.open(
                            "http://" + "fengnan." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流古冶") {
                        window.open(
                            "http://" + "guye." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流曹妃甸") {
                        window.open(
                            "http://" + "caofeidian." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流迁安") {
                        window.open(
                            "http://" + "qianan." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流遵化") {
                        window.open(
                            "http://" + "zunhua." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流迁西") {
                        window.open(
                            "http://" + "qianxi." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流玉田") {
                        window.open(
                            "http://" + "yutian." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流滦县") {
                        window.open(
                            "http://" + "luanxian." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流滦南") {
                        window.open(
                            "http://" + "luannan." + "560315.com/",
                            "_blank"
                        );
                    } else if (val == "物流乐亭") {
                        window.open(
                            "http://" + "laoting." + "560315.com/",
                            "_blank"
                        );
                    }
                    document
                        .querySelector("body")
                        .setAttribute("style", "overflow: auto !important;");
                    return;
                }
            }
            that.$message({
                message: val + "暂未开通",
            });
        },
    },

    created() {
        this.getconpany();
        this.getWallMap();
        this.getIndustry();
        this.getnodelist();
        this.getlinklist();
        this.getlinklistxh();
        this.getlinklistmt();
        this.getJobs();
        this.getInformteam();
        this.getparkInformation1();
        this.getparkInformation2();
        this.getparkInformation3();
        this.getparkInformation4();
        this.getparkInformation6();
        this.getWareInformation1();
        this.getWareInformation2();
        this.getWareInformation3();
        this.getWareInformation4();
        this.getWareInformation6();
        if (this.isshowit === "true") {
            this.getMemberType();
        }
    },
};
</script>

<style scoped>
.menu-title {
    height: 40px;
    line-height: 40px;
    background: #f8fbff;
    font-size: 18px;
    font-weight: 400;
    color: #000000;
    padding-left: 10px;
    overflow: hidden;
}
.t_yxline .t_tle {
    line-height: 40px;
    padding: 10px 0 0;
    text-align: center;
}
.t_yxline li {
    margin-top: 12px;
    position: relative;
}
.t_yxline li i {
    position: absolute;
    left: 0;
    bottom: 4px;
    z-index: 10;
}
.t_zx_tle {
    height: 42px;
    line-height: 42px;
    background: #f9f9f9;
    padding: 0 10px;
}

.t_li ul li {
    line-height: 36px;
    display: block;
    height: 36px;
}
.t_li ul li a span {
    color: #9e9e9e;
    font-size: 23px;
    float: left;
    padding-right: 5px;
}
.t_li ul li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #666;
}

.t_wlml {
    padding-bottom: 27px;
}
.t_wlml ul {
    margin-left: -10px;
    margin-top: -10px;
    overflow: hidden;
}
.t_wlml li {
    width: 346px;
    padding: 18px;
    line-height: 24px;
    background: #f9f9f9;
    margin-left: 10px;
    margin-top: 10px;
    float: left;
}
.t_wlml li:hover {
    background: #f7fbff;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}
.t_links {
    line-height: 32px;
    padding: 10px 0 20px;
    overflow: hidden;
}
.t_links li {
    float: left;
}
.t_links a {
    color: #666;
    display: inline-block;
}
.t_links span {
    font-size: 12px;
    color: #dadada;
    padding: 0 18px;
}
.t_hydt {
    padding-bottom: 15px;
}
.t_hydt ul {
    margin-top: 10px;
    display: block;
}
.t_hydt ul li {
    line-height: 32px;
}
.t_hydt ul li a {
    color: #666;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.t_hydt ul li a span {
    color: #9e9e9e;
    font-size: 23px;
    float: left;
    padding-right: 5px;
}
.t_hydt ul li a i {
    line-height: 32px;
    display: block;
    color: #333;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
    padding-bottom: 5px;
    font-style: normal;
}
.t_img_li ul {
    margin-left: -16px;
    display: block;
    overflow: hidden;
    padding-bottom: 20px;
}
.t_img_li li {
    width: 220px;
    float: left;
    margin-left: 16px;
    position: relative;
}
.t_img_li li div.color9 {
    line-height: 30px;
    padding: 0 5px;
    overflow: hidden;
}
.t_img_li li div.color9.mt10 {
    margin-top: 10px;
}
.t_img_li li div.color9 .el-image {
    margin-bottom: 0;
}
.t_img_li li .el-image {
    margin-bottom: 5px;
}
.t_li ul li a:hover,
.t_hydt ul li a:hover,
.t_hydt ul li a:hover i,
.t_links a:hover {
    color: #0060c6;
}
.xhhylist li {
    display: block;
    line-height: 30px;
}
.xhhylist li p {
    line-height: 24px;
}
.xhhylist li a.f14 {
    display: block;
    float: left;
    width: 420px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.t_img_li li a.position_rel {
    display: block;
    width: 220px;
    height: 220px;
}
.t_tjimg {
    position: absolute;
    left: 0;
    bottom: 1px;
    width: 41px;
    height: 21px;
}
.t_xhcontent .t_onte {
    line-height: 24px;
    text-indent: 2rem;
}
.h700 {
    height: 700px;
}
.t_menulist {
    position: fixed;
    top: 235px;
    left: 50%;
    margin-left: 620px;
    width: 48px;
}
.t_menulist li {
    display: block;
    cursor: pointer;
    background: #fff;
    border-bottom: 1px solid #f2f2f2;
    padding: 5px 10px;
    text-align: center;
    color: #666;
}
.t_menulist li:hover,
.t_menulist li.t_xzhouer {
    background: #0060c6;
    color: #fff;
}
.t_menulist li.t-gotop {
    background: #b8b8b8;
    color: #fff;
    border: 0;
}
.t_menulist li.t-gotop i {
    display: block;
    margin: 0 auto;
}
.t_menulist li.t-gotop:hover {
    background: #fd5705;
}
.indistrylist {
    padding: 0px 0 10px 15px;
    position: relative;
}
.indistrylist li {
    display: block;
    line-height: 35px;
    padding-top: 10px;
}
.indistrylist li a {
    color: #333;
}
.indistrylist li i {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: block;
    float: left;
    margin-right: 5px;
}
.indistrylist li i.wljy1 {
    background: #f2f9fc url(/static/images/small.png) no-repeat -309px -166px;
}
.indistrylist li i.yjll1 {
    background: #f2f9fc url(/static/images/small.png) no-repeat -383px -166px;
}
.indistrylist li i.tchy1 {
    background: #f2f9fc url(/static/images/small.png) no-repeat -347px -166px;
}
.indistrylist li i.yyjhy1 {
    background: #f2f9fc url(/static/images/small.png) no-repeat -275px -166px;
}
.indistrylist li i.wljy2 {
    background: #f2f9fc url(/static/images/small.png) no-repeat -606px -51px;
}
.indistrylist li i.yjll {
    background: #f2f9fc url(/static/images/small.png) no-repeat -141px -1px;
}
.indistrylist li i.tchy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -275px -52px;
}
.indistrylist li i.yyjhy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -274px 1px;
}
.indistrylist li i.gthy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -408px -106px;
}
.indistrylist li i.snhy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -406px -51px;
}
.indistrylist li i.mthy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -735px -51px;
}
.indistrylist li i.slhy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -473px -51px;
}
.indistrylist li i.hghy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -140px -51px;
}
.indistrylist li i.ysjs {
    background: #f2f9fc url(/static/images/small.png) no-repeat -207px -1px;
}
.indistrylist li i.bolhy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -207px -161px;
}
.indistrylist li i.mchy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -12px -104px;
}
.indistrylist li i.sphy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -339px -53px;
}
.indistrylist li i.ncphy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -669px -51px;
}
.indistrylist li i.yyhy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -77px 0px;
}
.indistrylist li i.jdhy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -272px -104px;
}
.indistrylist li i.wjhy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -77px -52px;
}
.indistrylist li i.qphy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -539px -52px;
}
.logisticslist {
    padding: 0px 0 10px 0px;
    position: relative;
}
.logisticslist li {
    display: block;
    line-height: 29px;
    padding-top: 7px;
    width: 50%;
    float: left;
    text-align: center;
    cursor: pointer;
}
.logisticslist li a {
    color: #333;
}
.logisticslist li i {
    border-radius: 50%;
    width: 42px;
    height: 42px;
    display: block;
    margin: 0 auto;
}
.logisticslist li i.wljy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -739px -3px;
}
.logisticslist li i.wlxx {
    background: #f2f9fc url(/static/images/small.png) no-repeat -675px -4px;
}
.logisticslist li i.wlzx {
    background: #f2f9fc url(/static/images/small.png) no-repeat -411px -3px;
}
.logisticslist li i.ldwl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -143px -109px;
}
.logisticslist li i.csps {
    background: #f2f9fc url(/static/images/small.png) no-repeat -82px -165px;
}
.logisticslist li i.cpzy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -145px -165px;
}
.hoverbox {
    position: absolute;
    left: 210px;
    top: -40px;
    width: 988px;
    height: 229px;
    background: #ffffff;
    border: 1px solid #dadada;
    z-index: 10;
}
.hoverbox li {
    float: left;
    width: 109px;
    text-align: center;
    font-size: 13px;
    margin-top: 11px;
}
.hoverbox li i {
    border-radius: 50%;
    width: 51px;
    height: 51px;
    display: block;
    margin: 0 auto;
    float: none;
}
.hoverbox li i.wljy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -735px 1px;
}
.hoverbox li i.wlxx {
    background: #f2f9fc url(/static/images/small.png) no-repeat -670px 0px;
}
.hoverbox li i.wlzx {
    background: #f2f9fc url(/static/images/small.png) no-repeat -407px 1px;
}
.hoverbox li i.ldwl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -140px -104px;
}
.hoverbox li i.csps {
    background: #f2f9fc url(/static/images/small.png) no-repeat -78px -160px;
}
.hoverbox li i.cpzy {
    background: #f2f9fc url(/static/images/small.png) no-repeat -140px -162px;
}
.hoverbox li i.wlyq {
    background: #f2f9fc url(/static/images/small.png) no-repeat -539px -1px;
}
.hoverbox li i.tlwl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -207px -51px;
}
.hoverbox li i.hywl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -339px -107px;
}
.hoverbox li i.kywl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -207px -105px;
}
.hoverbox li i.dsly {
    background: #f2f9fc url(/static/images/small.png) no-repeat -472px -105px;
}
.hoverbox li i.llwl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -76px -105px;
}
.hoverbox li i.yywl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -12px -1px;
}
.hoverbox li i.whwl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -140px -51px;
}
.hoverbox li i.djwl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -12px -162px;
}
.hoverbox li i.gkwl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -538px -105px;
}
.hoverbox li i.yjwl {
    background: #f2f9fc url(/static/images/small.png) no-repeat -339px -1px;
}
.hoverbox li i.hcxs {
    background: #f2f9fc url(/static/images/small.png) no-repeat -671px -105px;
}
.hoverbox li i.hcsc {
    background: #f2f9fc url(/static/images/small.png) no-repeat -605px -104px;
}
.hoverbox li i.wlxxh {
    background: #f2f9fc url(/static/images/small.png) no-repeat -605px 1px;
}
.hoverbox li i.wljr {
    background: #f2f9fc url(/static/images/small.png) no-repeat -11px -51px;
}
.hoverbox li i.wlzb {
    background: #f2f9fc url(/static/images/small.png) no-repeat -471px -1px;
}
.logisticslist .hoverbox {
    height: 273px;
}
.logisticslist .hoverbox li {
    width: 89px;
    margin-top: 20px;
    line-height: 47px;
}
.logisticslist .hoverbox.het195 {
    height: 195px;
}
.logisticslist .hoverbox.het195 li {
    width: 139px;
    height: 37px;
    line-height: 37px;
    margin-left: 22px;
    background: #f2f9fc;
    padding-top: 0;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue